{
  "common": {
    "productNoun": {
      "form": "skjema",
      "survey": "undersøkelse",
      "quiz": "quiz"
    },
    "productNounCapitalized": {
      "form": "Skjema",
      "survey": "Spørreundersøkelse",
      "quiz": "Quiz"
    },
    "urlField": {
      "settingsTitle": "Definer innstillingene for nettadressefeltet",
      "description": "Velg hvilke typer nettadresser som er tillatt for dette feltet.",
      "allowAllDomains": "Tillat alle domener",
      "allowAllDomainsDescription": "Enhver gyldig URL godtas.",
      "allowOnlyDomains": "Tillat kun disse domenene",
      "allowOnlyDomainsDescription": "Alt annet blir avvist.",
      "blockDomains": "Blokker disse domenene",
      "blockDomainsDescription": "Alt annet aksepteres.",
      "domainsAllowed": "Tillatte domener",
      "domainsBlocked": "Blokkerte domener",
      "domainPlaceholder": "f.eks. example.com",
      "domainPlaceholderAdd": "Legg til et til",
      "domainHint": "Skriv inn et domene, og trykk på Enter for å legge til.",
      "invalidDomain": "Skriv inn et gyldig domene uten http://, https:// eller en sti.",
      "domainRequired": "Legg til minst ett domene for dette alternativet.",
      "singleUrlInfo": "Kun én nettadresse støttes per felt. For å registrere flere nettadresser må du opprette separate felt."
    },
    "px": "piksler",
    "px_uppercase": "PX",
    "seconds": "sekunder",
    "other": "-- Annet --",
    "customFieldExistsError": "Tilpasset filt med dette navnet finnes allerede",
    "requiredField": "Dette feltet er påkrevd",
    "uniqueKeyNotUniqueError": "Denne viktige er ikke unik",
    "save": "Lagre",
    "saving": "Lagrer",
    "typeAnOption": "Skriv inn et alternativ",
    "unsaved": "Ikke lagret",
    "noSubmissionsFound": "Fant ingen innleveringer",
    "sortBy": "Sorter via",
    "clearAll": "Fjern alle",
    "submitSurvey": "Send inn undersøkelse",
    "select": "Velg",
    "data": "Info",
    "enterAmount": "Skriv inn mengde",
    "disqualifyAfterSubmitLower": "Diskvalifiser etter innsending",
    "errorRetryAgain": "Feil, prøv på nytt",
    "savedSuccessfully": "Lagret.",
    "couldntSaveChanges": "Kunne ikke lagre endringer. Prøv igjen.",
    "emailNotificationSettingsUpdated": "Innstillingene for e-postvarsling har blitt oppdatert.",
    "autoResponderSettingsUpdated": "Innstillingene for automatisk svar er oppdatert.",
    "bubbleRadioStyleImageAlt": "Bobleradiostil",
    "standardRadioStyleImageAlt": "Standard radiostil",
    "recurringFrequency": {
      "once": "Én gang",
      "daily": "Daglig",
      "weekly": "Ukentlig",
      "monthly": "Månedlig",
      "yearly": "Årlig"
    },
    "saveExitConfirmationSubText": "Vis en bekreftelsesdialog når brukeren forlater siden.",
    "yes": "Ja",
    "no": "Nei",
    "updated": "Oppdatert",
    "new": "Ny",
    "title": "Tittel",
    "openSettings": "Åpne innstillinger",
    "cloneField": "Klonefelt",
    "removeField": "Fjern felt",
    "description": "Beskrivelse",
    "cannotAddThisField": "Dette feltet kan ikke legges til.",
    "cannotAddThisFieldSubheading": "Dette {product} bruker allerede {existing} felt. Fjern alle felt fra 1 objekt før du legger til {attempted} felt.",
    "overallOnly": "Kun samlet",
    "nextSlideDefault": "Neste lysbilde (standard)",
    "nextQuestion": "Neste spørsmål",
    "searchAddress": "Søk etter adresse",
    "recurringDonation": "Gjentakende donasjon",
    "recurringDonationDay": "Gjentakende donasjon 1 dag",
    "recurringDonationWeek": "Gjentakende donasjon 1 gang i uken",
    "recurringDonationMonth": "Gjentakende donasjon 1 måned",
    "recurringDonationYear": "Årlig gjentakende donasjon",
    "integrate": "Integrere",
    "share": "Del",
    "email": "E-post",
    "connections": "Tilkoblinger",
    "comingSoon": "Kommer snart",
    "newWorkflow": "Ny arbeidsflyt",
    "workflow": "Arbeidsflyt",
    "funnel": "Trakt",
    "website": "Nettsted",
    "notConnectedToWorkflow": "Denne {asset} er ennå ikke koblet til en arbeidsflyt",
    "workflowEmptyDescription": "Send en bekreftelse på e-post, varsle teamet ditt eller merk nye kundeemner automatisk når noen sender inn dette {asset}.",
    "workflowName": "Arbeidsflytnavn",
    "workflowStatus": "Status",
    "workflowLastUpdated": "Sist oppdatert",
    "workflowStatusPublished": "Publisert",
    "workflowStatusDraft": "Utkast",
    "openInNewTab": "Åpne i ny fane",
    "moreActions": "Flere handlinger",
    "rename": "Gi nytt navn",
    "workflowsShowingFirst": "Viser de første {count} arbeidsflytene",
    "retry": "Prøv på nytt",
    "workflowsLoadError": "Kunne ikke laste inn tilknyttede arbeidsflyter.",
    "renameWorkflow": {
      "title": "Gi arbeidsflyt nytt navn",
      "description": "Gi denne arbeidsflyten et navn som beskriver hva den gjør.",
      "nameLabel": "Navn",
      "namePlaceholder": "Skriv inn navnet på arbeidsflyten",
      "nameRequired": "Arbeidsflytnavn er obligatorisk"
    },
    "deleteWorkflow": {
      "title": "Slett arbeidsflyt",
      "confirmDescription": "Er du sikker på at du vil slette «{name}»? Når den er slettet, vil den flyttes til fanen \"Slettet\" og vil bli fjernet permanent etter 30 dager."
    },
    "workflowRenamed": {
      "title": "Arbeidsflyten har fått nytt navn",
      "description": "Denne arbeidsflyten heter nå «{name}»."
    },
    "workflowDeleted": {
      "title": "Arbeidsflyt slettet",
      "description": "\"{name}\" har blitt slettet."
    },
    "workflowRenameFailed": {
      "title": "Kunne ikke endre navn på arbeidsflyten",
      "description": "Prøv på nytt senere."
    },
    "workflowDeleteFailed": {
      "title": "Kunne ikke slette arbeidsflyt",
      "description": "Prøv på nytt senere."
    },
    "exampleDomain": "example.com",
    "preview": "Forhåndsvisning",
    "back": "Tilbake",
    "close": "Lukk",
    "goHighLevel": "GoHighLevel",
    "openMediaLibrary": "Åpne mediebibliotek",
    "alert": "Varsel",
    "proceed": "Fortsett",
    "confirm": "Bekreft",
    "cancel": "Kanseller",
    "delete": "Slett",
    "embed": "Sett inn",
    "link": "Sammenkoble",
    "linkModal": {
      "title": "Sett inn lenke",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.example.com",
      "invalidUrl": "URL-en er ugyldig"
    },
    "iframeEmbed": "Iframe innebygd",
    "styles": "Stiler",
    "options": "Alternativer",
    "quickAdd": "Hurtigtillegg",
    "customFields": "Egendefinerte felt",
    "addObjectFields": "Legge til gjenstandfelter",
    "personalInfo": "Personlig informasjon",
    "contactInfo": "Kontaktinformasjon",
    "submit": "Send inn",
    "address": "Adresse",
    "customized": "Tilpasset",
    "layout": "Oppsett",
    "showLabel": "Vis etikett",
    "showImage": "Vis bilde",
    "imageLayout": "Bildeoppsett",
    "imageLayoutSettings": "Bilde Innholdsjustering Konfig",
    "imageLayoutMode": "Bildeoppsettmodus",
    "surveyDefault": "Spørreundersøkelse som standard",
    "independent": "Uavhengig",
    "image": "Bilde",
    "desktop": "PC",
    "mobile": "Mobil",
    "desktopImage": "Skrivebordsbilde",
    "mobileImage": "Mobil Bilde",
    "uploaded": "Lastet opp",
    "changeImage": "Endre bilde",
    "uploadImage": "Last opp bilde",
    "remove": "Fjern",
    "background": "Bakgrunn",
    "buttonBackground": "Bakgrunn for Knapp",
    "gradient": "Gradient",
    "type": "Type",
    "linear": "Lineær",
    "radial": "Radial",
    "angular": "Angulær",
    "angle": "Vinkel",
    "stops": "Stopper",
    "startColor": "Startfarge",
    "endColor": "Avslutningsfarge",
    "addColor": "Legg til farge",
    "fontColour": "Skriftfarge",
    "textFontColour": "Skriftfarge på tekst",
    "subTextFontColour": "Skriftfarge på undertekst",
    "selectThemes": "Velge tema",
    "selectOne": "Velg en",
    "enableIcon": "Aktiver ikonet",
    "iconType": "Ikontype",
    "iconPlacement": "Ikonplassering",
    "filled": "Utfylt",
    "textOnly": "Kun Hoveddel",
    "border": "Kant",
    "borderType": "Kanttype",
    "cornerRadius": "Hjørneradius",
    "width": "Bredde",
    "padding": "Padding",
    "top": "Topp",
    "bottom": "Bunn",
    "left": "Venstre",
    "right": "Høyre",
    "center": "Senter",
    "default": "Standard",
    "formDefault": "Standardskjema",
    "shadow": "Skygge",
    "color": "Farge",
    "horizontal": "Horisontal",
    "vertical": "Vertikal",
    "blur": "Uskarphet",
    "spread": "Spredning",
    "fieldStyle": "Feltstil",
    "fontColor": "Skriftfarge",
    "inputTextFillColor": "Fyllfarge for inndatatekst",
    "inputTextColor": "Tekstfarge for inndata",
    "primaryColor": "Primærfarge",
    "primaryColorTooltip": "Styrer Farge for svevetilstand og Dynamisk Land.",
    "primaryColorTooltipLearnMore": "Les mer",
    "inputTextColorTooltip": "Styrer Farge av Tekste skrevet i tilbakemelding Felter.",
    "mapPrimaryColorToButtonColor": "Kartlegg PRIMÆR Farge til Knapp Farge",
    "label": "Merkelapp",
    "fontFamily": "Fontfamilie",
    "size": "Størrelse",
    "weight": "Vekt",
    "fontWeightTooltip": "Gjelder i tilfelle avsnitt",
    "fontWeightOptions": {
      "thin": "100 - Tynn",
      "extraLight": "200 - Ekstratynn",
      "light": "300 - Mager",
      "normal": "400 - Normal",
      "medium": "500 - Medium",
      "semiBold": "600 - Halvfet",
      "bold": "700 - Fet"
    },
    "placeholder": "Plassholder",
    "customCSS": "Tilpasset CSS",
    "backgroundImage": "Bakgrunnsbilde",
    "headerImage": "Overskriftsbilde",
    "miscellaneous": "Diverse",
    "agencyBranding": "Byråmerkevarebygging",
    "imageUploadMessage": "Klikk eller dra et bilde til dette området for å laste opp",
    "backgroundImageTooltipMessage": "Bakgrunnsbildet er ment å dekke hele siden, og gir et visuelt tiltalende bakteppe for skjemaet. For å se bakgrunnsbildet, klikk på forhåndsning.",
    "headerImageTooltipMessage": "Topptekstbildet er utformet slik at det dekker hele bredden på skjemaet og forblir plassert øverst i skjemaet. For å se topptekstbildet, klikk på forhåndsvisning.",
    "onSubmit": "Ved innsending",
    "facebookPixelID": "Facebook-Pixel-ID",
    "facebookPixelFunnelLabel": "Bruke dette i en trakt?",
    "facebookPixelFunnelText": "La det stå tomt – traktens egne innstillinger for Pixel og samtykke til informasjonskapsler gjelder.",
    "facebookPixelEmbedLabel": "Bygge inn på et annet nettsted?",
    "facebookPixelEmbedText": "Velg hvordan samtykke til informasjonskapsler skal håndteres i trinnet Bygg inn kode.",
    "facebookPixelConsentCallout": "Samtykke til informasjonskapsler er angitt per integrering, under",
    "facebookPixelConsentCalloutLink": "Integrer → Bygg inn kode",
    "facebookPixelEvents": "Facebook Pixel Events",
    "onpageView": "Ved sidevisning",
    "stickyContact": "Klistret kontakt",
    "stickyContactMessage": "Husker og fyller automatisk ut kontaktopplysninger når brukeren kommer tilbake på samme enhet og med samme nettleser.",
    "generateSubmissionDocument": "Generer innsendelsesdokument",
    "generateSubmissionDocumentMessage": "Opprett en utskrivbar PDF av hver innsending automatisk, og legg den ved i kontaktens dokumenter",
    "saveQuizSubmissionAsPdf": "Lagre quizinnsendelsen som PDF",
    "saveQuizResultAsPdf": "Lagre quizresultatet som PDF",
    "showSubmissionInConversationsFeed": "Opprett samtale ved innsending",
    "showSubmissionInConversationsFeedMessage": "Opprett automatisk en samtaletråd når dette skjemaet sendes inn, slik at du kan følge opp via e-post, SMS eller andre kanaler fra fanen Samtaler.",
    "fieldDescription": "Beskrivelse av felt",
    "fieldTitle": "Tittel på felt",
    "queryKey": "Spørsmålsnøkkel",
    "querykeyTooltipMessage": "Spørsmålsnøkkelen som kan brukes som URL-parameter for å fylle ut dette feltet",
    "required": "Obligatorisk",
    "hidden": "Skjult",
    "hiddenValue": "Skjult verdi",
    "enableCountryPicker": "Aktiver landvelger",
    "altText": "Alt. tekst",
    "optionImageAlt": "Alternativ-bilde",
    "bannerAlt": "banner",
    "avatarAlt": "Navn på avatar",
    "alignment": "Justering",
    "imageWidth": "Bildebredde",
    "imageHeight": "Bildehøyde",
    "logic": "Logikk",
    "pleaseInput": "Skriv inn",
    "editHTML": "Rediger HTML",
    "textStyle": "Tekststil",
    "subText": "Undertekst",
    "text": "Tekst",
    "buttonStyle": "Knappestil",
    "fullWidth": "Full bredde",
    "htmlMessage": "Tilpasset HTML skal være her",
    "htmlEditorHeader": "TILPASSET JAVASCRIPT/HTML",
    "htmlEditorBodyMessage": "Legg til koden din her",
    "scriptAdded": "Skript er lagt til!",
    "sourceAddedForm": "Kilde «Navn på skjema»",
    "sourceAddedSurvey": "Kilde «Navn på undersøkelse»",
    "sourceAddedQuiz": "Kilde «Navn på quiz»",
    "yesSave": "Ja, lagre",
    "cancelKeep": "Avbryt, behold",
    "done": "Fullført",
    "addElement": "Legg til element",
    "addUrlLike": "Inkluder gyldige URL-er som",
    "doNotAddRelativePath": "Ikke legg til relative baner som",
    "or": "eller",
    "addCustomFields": "Legg til egendefinerte felt",
    "customFieldSearch": "Søk etter navn",
    "selectedCount": "{count} er valgt",
    "noFieldsFound": "Ingen felt funnet",
    "noFieldsMatchQuery": "Ingen felt samsvarer med \"{query}\". Prøv en annen søkeord eller opprett et nytt felt.",
    "clearSearch": "Tøm søk",
    "addFieldWithCount": "Legg til {count} felt | Legg til {count} felt",
    "noFieldsYet": "Ingen felt ennå",
    "noFieldsForObject": "Dette objektet har ingen felt ennå. Opprett et for å komme i gang.",
    "createField": "Opprett felt",
    "enterSourceValue": "Angi kildeverdi",
    "shortLabel": "Kort etikett",
    "shortLabelPlaceholder": "Font a Kort etikett",
    "labelPlaceholder": "Type en etikett",
    "imagePlaceholder": "Bilde",
    "fillValuesPlaceholder": "Legg til verdier",
    "customCSSTooltip": "Tilpasset CSS har forrang fremfor skjemastyling og temaer og kan ha innvirkning på temaets styling.",
    "fontFamilyTooltip": "Builder støtter alle typer skrifter hvis du ikke kan se det i listen. Søk i rullegardinmenyen",
    "angleTooltip": "Kontrollerer retningen til gradienten. 0° er til høyre, 90° er nedover, 180° er til venstre, 270° er oppover.",
    "useGDPRCompliantFont": "Bruk GDPR-kompatibel skrift",
    "enableTimezone": "Aktiver tidssone",
    "inputStyle": "Inndatastil",
    "conditionalLogicAlertOnSubmit": "Betinget logikk vil ha forrang over meldingen/omdirigeringen her",
    "conditionalLogicAlertOnShowHide": "Betinget logikk vil ha forrang over de skjulte innstillingene her",
    "placeholderFacebookPixelIdInput": "Skriv inn Facebook Pixel-ID",
    "doNotShowMessage": "Ikke vis igjen",
    "creatingForm": "Opprettet din Skjema...",
    "creatingSurvey": "Opprettet din Spørreundersøkelse...",
    "creatingQuiz": "Opprettet quizen din...",
    "errorCreatingForm": "Det var en feil Opprettet din Skjema. Vennligst prøv igjen.",
    "errorCreatingSurvey": "Det var en feil Opprettet din Spørreundersøkelse. Vennligst prøv igjen.",
    "errorCreatingQuiz": "Det oppsto en feil Opprettet quizen din. Vennligst prøv igjen.",
    "redirectMessage": "Du vil bli omdirigert til:",
    "themes": {
      "themes": "Temaer",
      "alertThemeMessage": "Hvis du bytter tema, vil du miste alle gjeldende stilendringer.",
      "useTheme": "Bruk tema",
      "removeTheme": "Fjern tema"
    },
    "box": "Boks",
    "line": "Linje",
    "message": "Melding",
    "openUrl": "Omdiriger til URL",
    "borderTypeList": {
      "dotted": "Stiplet",
      "dashed": "Stiplet",
      "solid": "Fast",
      "none": "Ingen"
    },
    "button": "Knapp",
    "emailNotification": "E-postvarsel",
    "emailNotificationSubheader": "Motta en e-post når noen fyller ut skjemaet ditt",
    "subject": "Tema",
    "emailTo": "E-post (til)",
    "senderName": "Navn på avsender",
    "senderNameWarning": "Ditt (underkontonavn) vil bli lagt til hvis det står tomt",
    "emailError": "Minst én e-postadresse er påkrevd",
    "emailTooltip": "Skriv inn én eller flere e-postadresser som skal motta dette varselet om innsending av skjema. Den første adressen går under \"Til\", mens ytterligere adresser behandles som \"CC\".",
    "emailTooltipForm": "Skriv inn én eller flere e-postadresser som skal motta dette varselet om innsending av skjema. Den første adressen går under \"Til\", mens ytterligere adresser behandles som \"CC\".",
    "emailTooltipSurvey": "Skriv inn én eller flere e-postadresser som skal motta dette varselet om innsending av undersøkelse. Den første adressen går under \"Til\", mens ytterligere adresser behandles som \"CC\".",
    "emailTooltipQuiz": "Skriv inn én eller flere e-postadresser som skal motta dette varselet om innsending av quiz. Den første adressen går under \"Til\", mens ytterligere adresser behandles som \"CC\".",
    "clear": "Fjern",
    "filter": "Filtrere",
    "noResults": "Ingen resultater",
    "search": "Søke",
    "showNotificationsSettings": "Vis varslingsinnstillinger",
    "emailServicePaid": "Denne funksjonen er en betalt tjeneste og vil medføre gebyrer basert på bruken din.",
    "integration": "Integrering",
    "validation": {
      "fieldRequired": "Filt er obligatorisk",
      "maxLengthExceeded": "Maks-lengden er overskredet ({max} tegn)"
    },
    "securityValidation": {
      "title": "Sikkerhetsproblemer ble oppdaget. Følgende er ikke tillatt:",
      "cookieAccess": "Tilgang til informasjonskapsler oppdaget (document.cookie). Dette er ikke tillatt av sikkerhetshensyn.",
      "storageAccess": "localStorage.getItem() – lesing fra localStorage er ikke tillatt.",
      "evalUsage": "Bruk av eval() er ikke tillatt, da det kan kjøre vilkårlig kode.",
      "dynamicFunction": "Dynamisk funksjonsoppretting (new Function) er ikke tillatt av sikkerhetshensyn.",
      "stringExecution": "Det er ikke tillatt å sende strenger til setTimeout/setInterval, da det kan kjøre vilkårlig kode. Bruk funksjonsreferanser i stedet.",
      "unclosedTag": "Uavsluttet HTML-tagg oppdaget (for eksempel en <style> uten en avsluttende </style>). Lukk alle tagger før du lagrer, ellers kan det hende at den publiserte siden ikke lastes inn."
    },
    "products": {
      "subscriptionBadge": "Abonnement",
      "trialBadge": "{days} dagers gratis prøveperiode",
      "setupFee": "Engangsgebyr for oppsett",
      "quantity": "Mengde",
      "productImageAlt": "Produktbilde",
      "bumpIconAlt": "Dytt-ikonet"
    },
    "payment": {
      "payments": "Betalinger",
      "paymentProviders": "Betalingsleverandører",
      "paymentProvidersDescription": "Koble til en betalingsleverandør for å begynne å godta betalinger.",
      "connectedProviders": "Tilkoblede leverandører",
      "requireCreditCard": "Krever kort for bestillinger på $0",
      "requireCreditCardTooltip": "Når det er aktivert, må kundene oppgi et kredittkort selv for kjøp på $0.",
      "connectProviders": "Koble til leverandører",
      "loading": "Laster inn ...",
      "generalTab": "Generelt",
      "productTab": "Produkt",
      "connected": "Tilkoblet",
      "connect": "Koble til",
      "liveModeOn": "Live-modus",
      "status": "Status",
      "test": "Test",
      "live": "Direkte",
      "paymentFields": "Betalingsfelt",
      "suggestAnAmount": "Foreslå et beløp",
      "recurringPayments": "Abonnementsbetalinger",
      "selectCurrency": "Velg valuta",
      "tagActiveBGColor": "Aktiv taggfarge",
      "includeOtherAmount": "Inkluder annet beløp",
      "footerInfo": "Bunntekstinfo",
      "paymentType": "Betalingstype",
      "sellProducts": "Selg produkter",
      "customAmount": "Tilpasset beløp",
      "collectPayment": "Innkreve betaling",
      "generalSettings": "Generelle felt",
      "securePayments": "*100 % Låse og trygge betalinger*",
      "error": {
        "addMainProductFirst": "Legg til et PRIMÆR Produkt først",
        "priceNotFoundForBumpProduct": "Pris ble ikke funnet for Fremhevet produkt",
        "productAlreadyAdded": "Produkt er allerede lagt til"
      },
      "product": {
        "addProduct": "Legg til produkt",
        "productSettings": "Produktinnstillinger",
        "bumpTag": "Dytt",
        "settingsAria": "Produktinnstillinger",
        "deleteAria": "Slett produkt",
        "selectProduct": "Velg produkt",
        "editThisProduct": "For å redigere dette produktet",
        "clickHere": "Klikk her",
        "show": "Vis",
        "description": "Beskrivelse",
        "image": "Bilde",
        "layoutSettings": "Layoutinnstillinger",
        "singleColumn": "En kolonne",
        "twoColumn": "To kolonner",
        "threeColumn": "Tre kolonner",
        "maxProductError": "Maksimalt 20 produkter er tillatt i et skjema",
        "productSelectPlaceholder": "Velg et produkt",
        "orderConfirmation": "Ordrebekreftelse",
        "orderConfirmationWarning": "Ordrebekreftelse vises når betalingen er gjennomført",
        "quantity": "Mengde",
        "createProduct": "For å oppretter et produkt",
        "noProductsAdded": "Ingen produkter lagt til ennå",
        "productsWillShowHere": "Når Du Inkludere-produkter, vil de Vise opp Høyre henne",
        "chooseProductType": "Velge Type",
        "mainProduct": "PRIMÆR Produkt",
        "primaryOffer": "Hovedtilbud",
        "checkoutAddOn": "Tillegg i kassen",
        "pricingOptions": "Prisalternativer",
        "pricingOptionsPlaceholder": "Velg prisalternativer (standard: alle)",
        "all": "ALLE",
        "addOrSelectProducts": "Legg til eller velg produkter",
        "onceYouAddProductsTheyWillShowUpRightHere": "Når du legger til produkter, vises de her",
        "addProducts": "Legg til produkter"
      },
      "bumProduct": {
        "price": "Pris",
        "variant": "Variant",
        "headline": "Overskrift",
        "otoHeadline": "OTO Overskrift",
        "otoText": "OTO Hoveddel",
        "enableImage": "Aktivere Bilde",
        "imageMessage": "Vi henter Standard produktbilde",
        "orUploadADifferentImage": "Eller Laste opp et annet bilde",
        "bumpProducts": "Bump-produkter",
        "bumpProduct": "Fremhevet produkt",
        "enableBump": "Aktivere Bump",
        "orderBumpStyle": "Tilleggsbestilling Stil",
        "classic": "Klassisk",
        "modern": "Moderne",
        "icon": "Ikon",
        "bumpTemplate": "Velge Mal",
        "highlightText": "Marker Hoveddel",
        "showPrice": "Vise Pris",
        "bumpPriceColor": "Høyeste Pris",
        "bumpIconColor": "Bump- Ikon",
        "bumpBackgroundColor": "Bump Bakgrunn",
        "highlightTextColor": "Marker Hoveddel",
        "headlineColor": "Overskrift",
        "otoHeadlineColor": "OTO Overskrift",
        "otoTextColor": "OTO Hoveddel",
        "bumpBorderColor": "Bump Kant",
        "priceRequired": "Pris er obligatorisk",
        "headlineRequired": "Overskrift er Obligatorisk",
        "otoHeadlineRequired": "Overskrift for engangstilbud er påkrevd",
        "otoTextRequired": "Tekst for engangstilbud er påkrevd",
        "bumpProductTooltip": "En Liten Tillegg tilbudt under Kasse å Multiplisere Sortere Verdi. Kunder kan inkludere det med et enkelt klikk.",
        "templateOne": "Mal 1",
        "templateTwo": "Mal 2",
        "templateThree": "Mal 3",
        "animationIcon": {
          "none": "Ingen",
          "arrow": "Pil",
          "fire": "Brann",
          "plus": "Pluss",
          "giftBox": "Boks",
          "timer": "Nedtelling",
          "cracker": "Kjeks",
          "snack": "Snack",
          "partyBalloon": "Festballong",
          "flash": "Blits",
          "money": "Valuta",
          "spaceShuttle": "Rom"
        }
      },
      "coupons": {
        "coupons": "Kuponger",
        "enableCoupon": "Aktiver kupong",
        "couponAlignment": "Kupongjustering",
        "left": "Venstre",
        "right": "Høyre",
        "fullWidth": "Full bredde",
        "tooltipMessage": "Angi plasseringen av kuponginndata fra typene nedenfor"
      }
    },
    "sellProductsAddress": {
      "shippingAddressDescription": "Bruker Address-elementet til å beregne avgift basert på kundens adresse.",
      "billingAddress": "Faktureringsadresse",
      "billingRequiresAddress": "Legg til et adresselement for å aktivere faktureringsadresse. Fakturering bruker adressefeltene sine.",
      "billingSameAsShipping": "Faktureringsadressen er den samme som leveringsadressen",
      "phoneNumber": "Telefonnummer",
      "billingAddressEnableFailed": "Vi kunne ikke aktivere feltene for faktureringsadresse. Prøv å lagre på nytt."
    },
    "addressSettings": {
      "autoComplete": "Automatisk utfylling av adresse",
      "addressfields": "Adressefelt",
      "placeholderSearch": "Søk etter en adresse",
      "autoCompleteTooltip": "Gir mulighet til å søke etter og automatisk fylle ut adresse.",
      "streetAddress": "Adresse",
      "autoCompleteAddressTitle": "Auto Fullfør Adresse",
      "newBadge": "ny",
      "defaultLabel": "Adresse",
      "searchPlaceholder": "Søke Adresse",
      "mandataorySearch": {
        "title": "Obligatorisk å velge adresse in Søke Bar",
        "primaryText": "Automatisk utfylling kun for Adresse",
        "secondaryText": "Når Aktivert, Når en Bruker samhandler med Adressefilten, Neste må de velge en gyldig adresse til Fortsette.",
        "secondaryText1": "Når deaktivert Neste kan de Fortsette uten å velge adresse in Søke-linjen."
      }
    },
    "autoResponder": "Automatisk svar",
    "workflow": "Arbeidsflyt",
    "workflowSubheader": "Automatiser hva som skjer etter at et skjema sendes inn",
    "workflowTitle": "Opprett din egen enkle arbeidsflyt.",
    "workflowDescription": "Bruk arbeidsflyter til oppfølginger etter at kontakter har engasjert seg med skjemaet ditt. For eksempel ved å sende dem en oppfølgings-e-post eller SMS",
    "createWorkflow": "Opprett arbeidsflyt",
    "workflowVisualAlt": "Visuell arbeidsflyt",
    "autoResponderSubheader": "Send en automatisk e-post til personen som sender inn skjemaet (e-post inneholder en kopi av informasjonen de skrev inn i skjemaet)",
    "replyToEmail": "Svar på e-post",
    "open": "Åpen",
    "won": "Vunnet",
    "lost": "Tapt",
    "abandon": "Forlatt",
    "selectAPipeline": "Velg en pipeline",
    "stage": "Etappe",
    "status": "Status",
    "opportunityValue": "Mulighetsverdi",
    "createNewPipeline": "Opprett ny pipeline",
    "editOpportunitySettings": "Rediger mulighetsinnstillinger",
    "contact": "Kontakt",
    "opportunity": "Mulighet",
    "business": "Bedrift",
    "add": "Legg til",
    "manage": "Administrer",
    "more": "Flere",
    "opportunityHeading": "Hvor vil du at muligheten din skal bli oppdatert?",
    "date": {
      "dateSettings": "Datoinnstillinger",
      "dateFormat": "Datoformat",
      "dateSeparator": "Datoseparator",
      "dateFormatTooltipMessage": "Velg et datoformat. D står for dag, M for måned og Å for år",
      "dateSeparatorTooltipMessage": "Velg en separator som vil skille dag, måned og år i format valgt under datoformat",
      "disablePicker": "Deaktiver velger"
    },
    "dateTime": {
      "tabGeneral": "Generelt",
      "tabFieldSettings": "Innstillinger for felt",
      "collectHeading": "Velg hva dette feltet skal samle inn",
      "collectDate": "Dato",
      "collectTime": "Tid",
      "collectDateTime": "Dato og klokkeslett",
      "collectTypeLockedTooltip": "Innsamlingstypen kan kun endres før feltet er lagret",
      "placeholderTextPlaceholder": "Legg til plassholdertekst",
      "shortLabelPlaceholder": "Legg til en kort etikett",
      "fieldSettingsBanner": "Definer den tillatte dato- eller tidsperioden, begrens hvilke dager brukerne kan velge, og velg hvordan verdien skal vises.",
      "allowedDateRange": "Tillatt datoperiode",
      "dateModeAny": "Hvilken som helst dato",
      "dateModeFuture": "Kun fremtidige datoer",
      "dateModePast": "Kun datoer i fortiden",
      "dateModeRange": "Spesifikk datoperiode",
      "futureQuestion": "Hvilke datoer kan brukerne velge?",
      "futureAny": "Enhver fremtidig dato",
      "futureAnyDesc": "Brukere kan velge hvilken som helst dato etter inneværende dato. F.eks. bestill et møte når som helst neste år.",
      "futureBuffer": "Etter buffertid",
      "futureBufferDesc": "Brukere kan kun velge datoer som ligger et bestemt antall dager frem i tid. F.eks. tillat bestillinger 3 dager fra i dag.",
      "futureBufferSuffix": "dager fra i dag",
      "futureRolling": "Innenfor en angitt datoperiode",
      "futureRollingDesc": "Brukere kan velge datoer innenfor en definert fremtidig datoperiode. F.eks. tillat bestillinger i løpet av de neste 30 dagene.",
      "futureRollingPrefix": "Neste",
      "futureRollingSuffix": "dager",
      "rangeLabel": "Spesifikk datoperiode",
      "rangeStart": "Startdato",
      "rangeEnd": "Sluttdato",
      "availableDays": "Ledige dager",
      "allowedTimeRange": "Tillatt tidsperiode",
      "timeModeAny": "Når som helst",
      "timeModeRange": "Spesifikk tidsperiode",
      "timeRangeLabel": "Spesifikk tidsperiode",
      "timeStart": "Starttid",
      "timeEnd": "Sluttid",
      "timeFormatLabel": "Tidsformat",
      "timeFormat24": "24 timer",
      "timeFormat12": "AM/PM",
      "timePlaceholder": "TT:MM",
      "defaultTimeLabel": "Standardtid",
      "defaultTimeHelper": "Forhåndsfyll med nåværende eller egendefinert tid.",
      "defaultTimeNone": "Ingen",
      "defaultTimeCurrent": "Nåværende",
      "defaultTimeCustom": "Egendefinert",
      "customTimeLabel": "Tilpasset tid",
      "customTimeError": "Angi en gyldig tid i HH:MM-format.",
      "disableCalendarPopup": "Deaktiver forgrunnsvinduet for kalenderen",
      "meridianAm": "AM",
      "meridianPm": "PM",
      "daysError": "Velg minst én tilgjengelig dag",
      "dateRangeError": "Sluttdatoen må være på eller etter startdatoen",
      "timeRangeError": "Sluttiden må være etter starttiden",
      "saveBlockedTitle": "Dato- og tidfeltet er ufullstendig",
      "saveBlockedDescription": "Rett de uthevede valideringsfeilene for dato og klokkeslett før du lagrer.",
      "weekday": {
        "mon": "Man",
        "tue": "Tir",
        "wed": "Ons",
        "thu": "Tor",
        "fri": "Fre",
        "sat": "Lør",
        "sun": "Søn"
      }
    },
    "restoreVersion": "Gjenopprett versjon",
    "versionHistory": "Versjonshistorikk",
    "versionPreviewTitle": "Versjonsforhåndsvisning",
    "errorMessage": "Feil, prøv på nytt",
    "version": "Versjon:",
    "currentVersion": "Nåværende versjon",
    "messageStyling": "Meldingsstil",
    "validateEmailHeader": "Bekreft e-post",
    "validateEmailDescription": "Knappen blir synlig når brukeren skriver inn e-posten sin. Denne funksjonen er utviklet for å hjelpe deg med å generere kvalitetsleads.",
    "verifyEmail": "Verifiser e-post",
    "validatePhoneHeader": "Valider telefon",
    "validatePhoneDescription": "Knappen blir synlig når brukeren går inn på telefonen sin. Denne funksjonen er utviklet for å hjelpe deg med å generere kvalitetsleads.",
    "verifyPhone": "Verifiser telefon",
    "validatePhoneWarning": "For å aktivere SMS OTP-verifisering, må du sørge for at telefonnummeret ditt er konfigurert i stedsinnstillingene dine",
    "addAnotherTnc": "Legg til andre bruksvilkår",
    "tnc1": "Bruksvilkår 1",
    "tnc2": "Bruksvilkår 2",
    "deleteCaps": "SLETT",
    "deleteConfirmation": "Skriv SLETT for å bekrefte",
    "marginPadding": "Margin og polstring",
    "style": {
      "formLayoutType": "Skjematype",
      "layoutType": "Type layout",
      "surveyType": "Type spørreundersøkelse",
      "oneColumn": "Én kolonne",
      "twoColumn": "To kolonner",
      "singleLine": "Én linje",
      "fieldWidth": "Feltbredde",
      "labelAlignment": {
        "labelAlignment": "Etikettjustering",
        "labelWidth": "Etikettbredde"
      },
      "fieldSpacing": "Avstand mellom feltene",
      "imageFieldSpacing": "Bilde- og feltavstand",
      "imageCornerRadius": "Hjørneradius for bilde",
      "color": "farge",
      "fontColor": "Skriftfarge",
      "inputBackgroundColor": "Bakgrunnsfarge for inndata",
      "inputBorder": "Tilbakemelding Kant",
      "layout": "Oppsett",
      "colorsAndBackground": "Farger og bakgrunn",
      "imageLayout": {
        "imageLayout": "Bildeoppsett",
        "showImage": "Vis bilde",
        "image": "Bilde",
        "desktop": {
          "topFixed": "Festet til toppen",
          "leftCenter": "Venstre sentrum",
          "rightCenter": "Høyre Sentrere",
          "leftFixed": "Venstre Satt",
          "rightFixed": "Fast Høyre",
          "background": "Bakgrunn"
        },
        "mobile": {
          "header": "Overskrift",
          "background": "Bakgrunn"
        }
      },
      "focusPoint": {
        "title": "Fokuspunkt",
        "reset": "Tilbakestill",
        "noImage": "Intet bilde er lastet opp"
      },
      "advanceSettings": "Avanserte Innstillinger",
      "inputField": "Inngangsfelt",
      "borderWidth": "Kantvidde",
      "borderColor": "Kantfarge",
      "borderStyle": "Kantlinjestil",
      "fontSize": "Skriftstørrelse",
      "fontWeight": "Skriftvekt",
      "labelColor": "Etikettfarge",
      "placeholderColor": "Plassholderfarge",
      "shortLabelColor": "Kort etikettfarge"
    },
    "replyToTooltip": "Angi e-postadressen hvor svarene på denne varslingen skal sendes. Bruk {'{'}{'{'}contact.email{'}'}{'}'} for å la mottakerne svare direkte til personen som fylte ut skjemaet.",
    "content": "Innhold",
    "calculations": "Beregninger",
    "uploadOptions": "Opplastingsalternativer",
    "opportunitySettingsWarning": "Vennligst sett opp mulighetsinnstillinger ved å klikke på knappen Edit Opportunity Settings.",
    "startValue": "Startverdi",
    "endValue": "Slutt",
    "today": "I dag",
    "thisWeek": "Denne uken",
    "last7Days": "Siste sju dager",
    "thisMonth": "Denne måneden",
    "last30Days": "Siste 30 dager",
    "question": "Spørsmål",
    "createContactOnPartialSubmission": "Opprett kontakt ved delvis innsending",
    "howItWorks": "Hvordan fungerer det?",
    "createContactOnPartialSubmissionDescription": "Fullfør lysbildet og klikk «Neste». En ny kontakt opprettes og lagres automatisk.",
    "swapWarningMessageSurvey": "Hvis du redigerer eller bytter alternativer, vil det påvirke dette egendefinerte feltet på alle steder der feltet brukes. Det kan også tilbakestille betinget logikk. ",
    "swapWarningMessageForm": "Hvis du redigerer eller bytter alternativer, vil det påvirke dette egendefinerte feltet på alle steder der feltet brukes. ",
    "migrationWarningMessage": "Denne funksjonaliteten har blitt overført til Survey Conditional Logic.",
    "optionLabel": "Alternativ-etikett",
    "calculationValue": "Beregningsverdi",
    "addOption": "Legg til alternativ",
    "addOtherOption": "Legg til «Annet»-alternativ",
    "otherOptionLabel": "Annet",
    "otherOptionPlaceholder": "Skriv inn et annet alternativ her",
    "enableCalculations": "Aktiver beregninger",
    "allowOtherOption": "Tillat annet alternativ",
    "productSelectionSubtext": "Aktivere Individ Eller flere produktvalg",
    "multi": "Flere",
    "single": "Individ",
    "productSelectionHeading": "Produkt",
    "spreadToColumns": "Fordel til kolonner",
    "columns": "Kolonner",
    "customstyle": "Stil",
    "standard": "Standard",
    "bubble": "Boble",
    "radioStyles": {
      "standardAlt": "Standard radiostil",
      "bubbleAlt": "Bobleradiostil"
    },
    "integratePopup": {
      "title": "Integrer skjema",
      "embedCode": "Bygge inn kode",
      "useInFunnelOrEmbedCode": "Bruk i trakt/innbyggingskode",
      "iframeEmbed": "Sett inn iframe",
      "layout": {
        "title": "Bygg inn layouttype",
        "description": "Velg en layout som skal bygges inn i en trakt eller et eksternt nettsted",
        "allowMinimize": "Tillat minimering",
        "minimizedTitlePlaceholder": "Minimert tittel",
        "leftAlignAlt": "Venstrejuster",
        "rightAlignAlt": "Høyrejuster"
      },
      "triggerType": "Triggertype",
      "triggers": {
        "seconds": "sekunder"
      },
      "activation": {
        "title": "Aktiveringsalternativer",
        "visit": "besøk"
      },
      "deactivation": {
        "title": "Alternativer for deaktivering",
        "times": "ganger"
      },
      "copyEmbedCode": "Kopier innebygd kode",
      "copyFormLink": "Kopier skjemalenke",
      "openFormLink": "Åpne skjemalenke",
      "invalidInput": "Ugyldig inndata!",
      "funnel": {
        "funnel": "Trakt",
        "chooseStep": "Velge a Sritt",
        "copyCodeAndOpenFunnel": "Kopiere Kode og Åpne Trakt"
      },
      "share": {
        "share": "Del",
        "shareViaSocials": "Slett Via sosiale medier",
        "copyLink": "Kopier lenke"
      },
      "email": {
        "email": "E-post",
        "shareViaEmail": "Slett Via e-post",
        "emailButton": "E-post",
        "blankTemplate": "Mal mal",
        "emailMarketingTemplates": "E-post Markedsføring",
        "or": "Eller",
        "chooseTemplate": "Velg fra dine maler",
        "continue": "Fortsette"
      }
    },
    "rating": {
      "icon": "Ikon",
      "iconAlignment": "Ikon Justering",
      "count": "Antall",
      "lowestRating": "Min.. Vurdering",
      "highestRating": "Maks-vurdering",
      "iconSelectedState": "Ikon Valgt Stat",
      "iconUnselectedState": "Ikon Ikke valgt Stat",
      "rating": "Vurdering",
      "ratingSettings": "Innstillinger",
      "calculationType": {
        "calculationType": "Hvordan Arkivere Rating Filt in Tilpasset Filt",
        "calculationTypeTooltip": "Når Du Hyppighet noe 4 Fra 5 stjerner, betyr det: - Absolutt: 4 Fra 5 - Prosentdel: 80 - Brøk: 0,8",
        "absolute": "Absolutt",
        "percentage": "Prosentdel",
        "fraction": "Brøk"
      }
    },
    "desktopMode": "Skrivebordmodus",
    "mobileMode": "Mobilmodus",
    "versions": "Varianter",
    "advanced": "Avansert",
    "edit": "Rediger",
    "settings": "Innstillinger",
    "submissions": "Innsendinger",
    "analytics": "Analyse",
    "notifications": "Varsler",
    "undo": "Angre",
    "redo": "Gjenta",
    "customValues": "Egendefinerte verdier",
    "pickBgFromImage": "Gjør bakgrunnen i meldingsboksen uskarp. Hvis du velger en bakgrunnsfarge for meldingsboksen, vises den over den uskarpe meldingsboksen.",
    "pickBgFromImageTip": "Velger en Farge med høy Sammenligne for BG Bilde. Melding: Vil ikke bli brukt hvis Skjemaets Bakgrunn ikke har et Bilde",
    "messageBackgroundBlur": "Bakgrunnsuskarphet",
    "confirmationMessage": "Bekreftelsesmelding",
    "deleteOption": "Slette-alternativ",
    "deleteConfirmationModal": {
      "defaultDescription": "Sletter et alternativ vil påvirke denne Tilpasset-filten på tvers av hvert eneste seter der filten brukes. Er du sikker på at du ønsker å Slette det?",
      "validationMessage": "Vennligst skriv inn Slette til Lagre.",
      "validationError": "Vennligst skriv inn Slette"
    },
    "disqualifyImmediately": "Diskvalifiser umiddelbart",
    "disqualifyAfterSubmit": "Diskvalifiser etter innsending",
    "generalSettings": "Generelt Innstillinger",
    "advancedSettings": "Avanserte Innstillinger",
    "customFieldName": "Tilpasset Industri Navn",
    "customFieldNameTooltip": "Denne Industri Navn er unik per Tilpasset Industri.",
    "customFieldNameTooltipContact": "Disse feltene lar brukerne registrere ytterligere detaljer om en person, som for eksempel type potensiell kunde, fødselsdag eller foretrukket kontaktmetode.",
    "customFieldNameTooltipContactLearnMore": "Les mer",
    "customFieldNameTooltipOpportunity": "Disse feltene brukes til å spore avtalespesifikke data for hver mulighet, inkludert informasjon som budsjett eller et sluttmål.",
    "customFieldNameTooltipOpportunityLearnMore": "Les mer",
    "customFieldNameTooltipCompany": "Disse feltene muliggjør innsamling av informasjon på organisasjonsnivå (f.eks. for leverandører, kunder eller byråer) som er knyttet til kontakter.",
    "customFieldNameTooltipCompanyLearnMore": "Les mer",
    "customFieldNameTooltipCustomObject": "Disse feltene lar brukerne samle inn bedriftsspesifikke data, som detaljer om eiendeler, kjøretøy eller eiendommer, og integrere denne informasjonen i CRM-systemet deres.",
    "customFieldNameTooltipCustomObjectLearnMore": "Les mer",
    "uniqueKey": "Unik nøkkel",
    "uniqueKeyTooltip": "Denne nøkkelen er systemidentifikatoren for det egendefinerte feltet. Når den er innstilt, kan den ikke endres.",
    "uniqueKeyTooltipLearnMore": "Les mer",
    "selectContactAssociation": "Velg assosiasjonen med Kontakter",
    "selectObjectAssociation": "Velg tilknytningen mellom {objectA} og {objectB}",
    "pickHowRecordsLink": "Begge objektene er på dette skjemaet, så innsendingen må vite hvordan de henger sammen.",
    "association": "Forening",
    "newAssociationBetween": "Ny tilknytning mellom {objectA} og {objectB}",
    "opportunitySetupTitle": "Sett opp denne muligheten",
    "opportunitySetupSubtitle": "Velg hvor det lander.",
    "opportunitySetupSubtitleLinked": "Velg hvor det lander, og hvordan det lenker til {object}.",
    "opportunityPlacement": "Plassering av salgsmulighet",
    "newPipeline": "Ny prosess",
    "associations": "Foreninger",
    "createNewAssociation": "Opprett ny assosiasjon",
    "selectAnAssociation": "Velg en assosiasjon",
    "loadingAssociations": "Laster inn tilknytninger...",
    "unknownAssociation": "Anonym Forhold",
    "manyToMany": "Mange til mange",
    "failedToLoadAssociations": "Mislyktes å laste inn tilknytninger.",
    "noAssociationsFound": "Ingen tilknytninger funnet",
    "keepThisField": "Beholde dette Industri",
    "customObject": "Egendefinerte objekter",
    "customObjects": "Egendefinerte objekter",
    "object": "Objekt",
    "editAssociation": "Rediger {objectName} -assosiasjon",
    "editAssociationButton": "{edit} {objectName} {association}",
    "fields": "Felt",
    "primaryFieldWarning": "{fieldName} er et PRIMÆR felt for {objectSingular} og er Obligatorisk for å opprette eller Oppdatere en {objectSingular}.",
    "primaryFieldTitle": "{fieldName} er obligatorisk for å opprette eller oppdatere {objectSingular} -dokument.",
    "removeAllFields": "Fjern alle {objectSingular} felter",
    "customObjectsFallback": "Egendefinerte objekter",
    "noneAssociation": "Ingen",
    "noneAssociationDescription": "Ingen Forhold til Kontakter (ingen Kontaktfelter her)",
    "survey": {
      "layoutType": "Type spørreundersøkelse",
      "oneQuestionPerPage": "Ett spørsmål om gangen",
      "allQuestionsOnePage": "Flere om gangen"
    },
    "quizQuestions": "Quiz Forespørsel",
    "choiceElements": "Choice Komponenter",
    "otherElements": "Annen/annet Komponenter",
    "listEditor": {
      "prefillValueHeader": "Verdi for Forhåndsfylle",
      "labelPlaceholder": "Merkelapp",
      "valuePlaceholder": "Verdi",
      "optionRequiredError": "Alternativet Felt er Obligatorisk"
    },
    "field": "Felt",
    "scoreEditor": {
      "addFieldPlaceholder": "Legge til Felt",
      "fieldLabel": "Felt",
      "numberLabel": "høy"
    },
    "fileUploadEditor": {
      "fileTypes": "Filtyper",
      "all": "hver eneste",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPEG",
      "xlsCsv": "XLS/CSV",
      "fileAccess": "Filtilgang",
      "fileAccessDescription": "Velg hvem som kan få tilgang til filer som lastes opp til dette feltet. Denne innstillingen kan ikke endres etter at feltet er opprettet.",
      "fileAccessLocked": "Når feltet er opprettet, kan ikke innstillingen for filtilgang endres.",
      "privateFiles": "Private filer",
      "privateFilesTooltip": "Kun autoriserte brukere kan se og laste ned filer.",
      "publicFiles": "Offentlige filer",
      "publicFilesTooltip": "Alle med fillenken kan se og laste ned filer."
    },
    "ok": "Ok",
    "allowMultipleFiles": "Tillat flere filer",
    "maxFileLimit": "Maksimal filgrense",
    "privacyPolicy": "Retningslinjer for personvern",
    "termsOfService": "Vilkår for tjenesten",
    "colorPicker": {
      "brandColors": "Merkevarefarger",
      "defaultColors": "Standardfarger",
      "globalCustomColors": "Globale tilpassede farger"
    },
    "billingFrequency": "Faktureringshyppighet",
    "otherAmount": "Annet beløp",
    "exampleUrlPlaceholder": "https://www.example.com",
    "checkboxStyles": {
      "standardAlt": "Standard avmerkingsboksstil",
      "bubbleAlt": "Boble avmerkingsboksstil"
    },
    "previewIcons": {
      "exportAlt": "Eksportikon",
      "shipmentAlt": "Forsendelsesikon",
      "resultAlt": "Ikon for resultatside"
    },
    "examples": {
      "sampleUrl": "https://example.com"
    },
    "showing": "Visning",
    "of": "av",
    "enterCouponCode": "Skriv inn kupongkode",
    "apply": "Bruk",
    "paymentWillBeProcessed": "Betalingen vil bli behandlet så snart du går videre til neste trinn",
    "paymentWillBeProcessedNextSlide": "Betalingen vil bli behandlet så snart brukeren går videre til neste lysbilde",
    "showThisAlertToUsers": "Vis dette varselet til brukerne",
    "sixteenDigitCardNumber": "16-sifret kortnummer",
    "mmYy": "MM / ÅÅ",
    "cvc": "CVC",
    "threeDigitCode": "Tresifret kode",
    "enterCardNumber": "Skriv inn kortnummer",
    "pleaseFillRequiredFields": "Fyll ut alle obligatoriske felter!",
    "opportunitySettingsIncomplete": "Mulighetsinnstillinger ufullstendige",
    "opportunitySettingsIncompleteDescription": "Dette skjemaet inkluderer felter for mulighet, men innstillingene for mulighet er ikke oppdatert. Konfigurer innstillingene for muligheter for å kunne lagre skjemaet.",
    "ariaAttributes": {
      "iconSearch": "Ikonsøk"
    },
    "alt": {
      "standardRadioStyle": "Standard radiostil",
      "bubbleRadioStyle": "Bobleradiostil"
    },
    "value": "Verdi",
    "jumpTo": "Hopp til",
    "thankYouJohnDoe": "Takk, Ola Nord",
    "total": "Total",
    "urlExamples": {
      "simple": "eksempel.no",
      "https": "https://eksempel.no",
      "withPath": "eksempel.no/sti",
      "fullPath": "https://www.eksempel.no/sti"
    },
    "quizThankYou": "Takk for at du tok deg tid til å svare på en quiz."
  },
  "overallScore": {
    "defaultTitle": "Total poengsum"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Individuelt valg",
      "multipleChoice": "Flere valg",
      "yesNo": "Ja /Nei",
      "shortAnswer": "Kort Besvart",
      "longAnswer": "Long Besvart",
      "number": "høy",
      "singleDropdown": "Individuell Rullegardinmeny",
      "multiDropdown": "Multi- Rullegardinmeny"
    },
    "personal": {
      "fullName": "Full Navn",
      "firstName": "Fornavn",
      "lastName": "siste Navn",
      "dateOfBirth": "Fødselsdato",
      "phone": "Telefon",
      "email": "Gmail",
      "fullNamePlaceholder": "Skriv inn hele navnet ditt",
      "firstNamePlaceholder": "Skriv inn fornavnet ditt",
      "lastNamePlaceholder": "Skriv inn etternavnet ditt",
      "dateOfBirthPlaceholder": "DD / MM / ÅÅÅÅ",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Knapp"
    },
    "integration": {
      "sellProducts": "Selg produkter",
      "collectPayment": "Innkreve Utbetaling"
    },
    "address": {
      "address": "Adresse",
      "streetAddress": "Adresse",
      "city": "By",
      "state": "Stat",
      "country": "Land",
      "postalCode": "Kode",
      "organization": "Organisasjon",
      "website": "Nettsted",
      "websitePlaceholder": "https://dittnettsted.no",
      "addressPlaceholder": "Gateadresse",
      "streetAddressPlaceholder": "Skriv inn hele adressen din",
      "cityPlaceholder": "Skriv inn byen din",
      "statePlaceholder": "Skriv inn fylket ditt",
      "countryPlaceholder": "Skriv inn landet ditt",
      "postalCodePlaceholder": "Postnummer",
      "organizationPlaceholder": "Skriv inn organisasjonen din"
    },
    "text": {
      "singleLine": "Individ Linje",
      "multiLine": "Flere Linje",
      "textBoxList": "Tekste Firkant Liste",
      "singleLinePlaceholder": "Skriv inn teksten din",
      "multiLinePlaceholder": "Skriv inn meldingen din her"
    },
    "choiceElements": {
      "singleDropdown": "Individuell Rullegardinmeny",
      "multiDropdown": "Multi- Rullegardinmeny",
      "checkbox": "Avmerkingsboks",
      "radio": "Radio",
      "singleDropdownPlaceholder": "Velg et alternativ",
      "multiDropdownPlaceholder": "Velg ett eller flere alternativer",
      "pictureChoice": {
        "label": "Bildevalg",
        "multipleSelection": "Flervalg",
        "selectionTypeLocked": "Valgtypen kan ikke endres etter at dette egendefinerte feltet er lagret.",
        "imageRequiredBeforeSave": "Hvert alternativ i et Bildevalg-element må ha et bilde.",
        "labelRequiredBeforeSave": "Hvert alternativ i et Bildevalg-element må ha en etikett.",
        "duplicateOptionLabelsBeforeSave": "Hvert alternativ i et Picture Choice-element må ha en unik merkelapp.",
        "selectionLimitInvalidBeforeSave": "Angi en gyldig utvalgsgrense for elementet Bildevalg.",
        "selectionLimit": "Utvalgsbegrensning",
        "unlimited": "Ubegrenset",
        "exact": "Nøyaktig",
        "range": "Rekkevidde",
        "exactSelections": "Nøyaktige valg",
        "minimum": "Minimum",
        "maximum": "Maksimum",
        "options": "Alternativer",
        "optionSettings": "Innstillinger for alternativer",
        "showOptionLabel": "Vis alternativ-etikett",
        "addOption": "Legg til alternativ",
        "otherOption": "Annet alternativ",
        "imageFit": "Bildetilpasning",
        "cover": "Forside",
        "contain": "Inneholder",
        "fill": "Fyll",
        "spreadToColumns": "Fordel til kolonner",
        "columns": "Kolonner",
        "numberOfColumns": "Antall kolonner",
        "desktopColumnsLimit": "Maksimalt {count} kolonner på desktop.",
        "mobileColumnsLimit": "Maksimalt {count} kolonner på mobil.",
        "otherOptionLabel": "Annen valgmulighetsetikett",
        "optionLabel": "Alternativ-etikett",
        "image": "Bilde",
        "media": "Media",
        "otherImageUploadUnavailable": "Et bilde kan ikke lastes opp for alternativet «Annet».",
        "removeImage": "Fjern bilde",
        "deleteOption": "Slett alternativ",
        "altText": "Alternativ tekst"
      }
    },
    "customized": {
      "text": "Tekste",
      "html": "Html",
      "htmlPlaceholder": "Tilpasset HTML skal være her",
      "captcha": "Captcha",
      "captchaDefaultLabel": "Utfordring",
      "botProtection": "Botbeskyttelse",
      "verificationMode": "Bekreftelsesmodus",
      "interactive": "Interaktiv",
      "invisible": "Usynlig",
      "invisibleModeDescription": "Denne bekreftelsen kjører automatisk i bakgrunnen og er ikke synlig for brukere",
      "fieldHiddenWarning": "Dette feltet er skjult og vises ikke på skjemaet.",
      "verifyHuman": "Bekreft at du er et menneske",
      "privacy": "Personvern",
      "help": "Hjelp",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Kilde",
      "termsAndConditions": "T & C",
      "termsAndConditionsPlaceholder": "Jeg godtar vilkår og betingelser Utstedt Via selskapet. Ved å oppgi telefonnummeret mitt, godtar jeg Arve tekste-meldinger fra virksomheten.",
      "score": "Poengsum",
      "scorePlaceholder": "Eks.: Poengsummen din er 100 %"
    },
    "other": {
      "url": "Nettadresse",
      "urlPlaceholder": "Skriv inn en nettadresse",
      "image": "Bilde",
      "fileUpload": "Laste opp av Fil",
      "monetary": "Monetær",
      "number": "høy",
      "datePicker": "Dato og klokkeslett",
      "datePickerLegacy": "Datovelger",
      "datePickerGeneratedName": "Dato",
      "timePickerGeneratedName": "Tid",
      "dateTimePickerGeneratedName": "Dato og klokkeslett",
      "signature": "Signatur",
      "monetaryPlaceholder": "Skriv inn mengde",
      "signaturePlaceholder": "Signer her",
      "numberPlaceholder": "Skriv inn et tall",
      "datePickerPlaceholder": "DD / MM / ÅÅÅÅ",
      "imageUploadPlaceholder": "Ingen bilder lagt til ennå",
      "imageUploadSubText": "Last opp til Medielagring eller dra og slipp",
      "imageUploadButtonText": "Last opp bilde",
      "fileText": "Fil",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG eller GIF",
      "fileUploadPlaceholder": "Klikk for å laste opp"
    },
    "customstyle": "Stil",
    "standard": "Standard",
    "bubble": "Boble"
  },
  "survey": {
    "addSlideText": "Legg til elementer",
    "defaultScreenTitle": "Dra og slipp komponenter",
    "defaultScreenDescription": "Flytt spørsmålet ditt til {pageIndex}-siden ved å bruke elementene til venstre.",
    "typeOfBuilder": "Spørreundersøkelse",
    "survyeStyle": "Stil for spørreundersøkelse",
    "surveyName": "Navn på spørreundersøkelse",
    "surveyElement": "Undersøkelseselement",
    "addSurveyElement": "Legg til undersøkelseselement",
    "cloneSlide": "Klone lysbilde",
    "unsavedAlertMessage": "Undersøkelsen har arbeid som ikke er lagret. Er du sikker på at du vil forlate og forkaste alt arbeid som ikke er lagret?",
    "thirdPartyScriptAlertMessage": "Tredjepartsskript inne i HTML-blokken kan gi sterk funksjonalitet, men de medfører også risiko for personvern, sikkerhet, ytelse og sideoppførsel. Vi anbefaler derfor at du leser gjennom innholdet i dette skriptet før du lagrer det i undersøkelsen.",
    "integrateHeader": "Integrer undersøkelsen",
    "integrateSubHeader": "Bruk følgende alternativer for å integrere den egendefinerte spørreundersøkelsen på nettstedet ditt",
    "integrateCopyLinkMessage": "Kopier lenken nedenfor og del den enkelt hvor du måtte ønske.",
    "onSurveySubmission": "Ved innsending av undersøkelse",
    "saveExitConfirmation": "Lagre fremdrift for undersøkelser",
    "surveySettings": "Innstillinger for undersøkelse",
    "oneQuestionAtTime": "Ett spørsmål om gangen",
    "backButton": "Tilbakeknapp",
    "backButtonTooltipMessage": "Tilbake-knappen vil hjelpe brukerne med å gå til forrige lysbilde",
    "disableAutoNavigation": "Deaktiver automatisk navigasjon",
    "disableAutoNavigationTooltipMessage": "Navigerer automatisk til Neste Skyve Etter a Bruker svarer.",
    "autoNavigation": "Auto navigasjon",
    "autoNavigationTooltipMessage": "Navigerer automatisk til Neste Skyve Etter a Bruker svarer.",
    "progressBar": "Fremdriftslinje",
    "progressBarTooltipMessage": "Hvis du slår denne av, fjernes fremdriftslinjen fra undersøkelsen",
    "disableAnimation": "Deaktiver animasjon",
    "disableAnimationTooltipMessage": "Hvis du slår denne på, deaktiveres lysbildeovergangsanimasjonen",
    "scrollToTop": "Bla til toppen",
    "scrollToTopTooltipMessage": "Hvis den er slått på, vil undersøkelsen gå til toppen på neste lysbilde",
    "submitSurvey": "Send inn undersøkelse",
    "disqualifyImmediately": "Diskvalifiser umiddelbart",
    "disqualifyAfterSubmit": "Diskvalifiser etter innsending",
    "disqualifyAfterSubmitLowerCase": "Diskvalifiser etter innsending",
    "footerHTML": "HTML for bunntekst",
    "footerHTMLMessage": "Du kan skrive tilpasset CSS (ved hjelp av stilkode) og HTML i samme boks",
    "editFooter": "Rediger bunntekst",
    "disqualifySettings": "Diskvalifiseringsinnstillinger",
    "disqualifyImmediatelyLabel": "Umiddelbart",
    "disqualifyAfterSubmitLabel": "Etter innsending",
    "slideConflictAlertMessage": "Dette lysbildet inneholder flere spørsmål som har logikk ved dem. Dette kan føre til utilsiktet atferd",
    "addSlide": "Legg til lysbilde",
    "settings": "Innstillinger",
    "delete": "Slett",
    "slideDeleteAlertMessage": "Er du sikker på at du vil slette denne lysbildet?",
    "slideDeleteBetweenAlertMessage": "Dette vil omorganisere de andre lysbildene, er du sikker på at du vil slette dette lysbildet?",
    "slideLabel": "Lysbilde {n}",
    "slideName": "Lysbildenavn",
    "slidePosition": "Skyveposisjon",
    "jumpTo": "Hopp til",
    "jumpToSubText": "Hopp til et spesifikt lysbilde",
    "enableTimezoneSurvey": "Hvis du aktiverer dette alternativet, registreres tidssoneinformasjonen til personen som sender inn undersøkelsen",
    "footer": {
      "footer": "Bunntekst",
      "enableNewFooter": "Aktiver ny bunntekst",
      "stickToSurvey": " Hold deg til undersøkelsen",
      "backgroundFill": "Bakgrunnsfyll",
      "footerHeight": "Høyde på bunntekst",
      "enableProgressBar": "Aktiver fremdriftslinje",
      "buttons": "Knapper",
      "button": "Knapp",
      "buttonType": "Knapptype",
      "buttonTypeTooltip": "Velg hvordan navigasjonsknappene skal vises i bunnteksten i undersøkelsen",
      "fillNext": "Fyll (neste)",
      "fillPrevious": "Fyll (tidligere)",
      "fillSubmit": "Fyll ut (send inn)",
      "textColor": "Knappetekst",
      "position": "Posisjon",
      "positionTooltip": "Velg hvordan navigasjonsknappene skal vises i bunnteksten i undersøkelsen",
      "previousText": "Forrige (tekst)",
      "nextText": "Neste (tekst)",
      "submitText": "Send inn (tekst)",
      "fillComplete": "Innfylling fullført",
      "fillInactive": "Innfylling inaktiv",
      "footerType": "Bunnteksttype",
      "stickToCard": "Sett fast på kortet",
      "stickToPage": "Sett fast på siden",
      "stepTextColor": "Sritt Hoveddel Farge",
      "progressBarFill": "Fremdriftslinje Fylle",
      "progressBarInactive": "Fremdriftslinje Inaktiv",
      "arrowFill": "Pil Fylle",
      "submitColorMobile": "Send inn (Farge)",
      "arrowFillColor": "Pil Fylle Farge",
      "buttonTypes": {
        "textAndArrow": "Text og pil",
        "onlyText": "Kun tekst",
        "onlyArrow": "Bare pil"
      },
      "positions": {
        "leftAndRight": "Venstre og høyre"
      },
      "placeholders": {
        "prev": "Forrige",
        "next": "Neste",
        "submit": "Send inn"
      }
    },
    "surveyNotfication": "Spørreundersøkelsesvarsel",
    "style": {
      "surveyPadding": "Undersøkelses-padding"
    },
    "integratePopup": {
      "shareOrEmbed": "Bygg inn eller del undersøkelsen",
      "share": {
        "openFormLink": "Åpne Spørreundersøkelse Lenke"
      },
      "email": {
        "emailSubheader": "Skape en tom e-post og Sett inn Spørreundersøkelsen din, Eller Velge a Mal og Sett inn it Umiddelbart."
      }
    },
    "autoResponderSubheader": "Send en automatisk e-post til personen som sender inn undersøkelsen (e-posten inneholder en kopi av informasjonen de har lagt inn i undersøkelsen)",
    "sendSubmissionsAsPdf": "Send undersøkelsesinnsending som en PDF",
    "switchToOneQuestionAtTimeOn": "Å aktivere «One Spørsmål at a Dato» forstyrrer din Nåværende betingede Logikk",
    "switchToOneQuestionAtTimeOff": "Deaktiver «One Spørsmål at a Dato» påvirker din betingede Logikk Konfig",
    "switchToOneQuestionAtTimeOnWarning": "Noen betingelser vil ikke lenger fungere som forventet Når spørsmålene er Møtte opp en mot en Dato.",
    "switchToOneQuestionAtTimeOffWarning": " Noen betingelser utviklet for Flyt med individuelle spørsmål vil slutte å fungere som tiltenkt.",
    "createContactOnPartialSubmissionSubText": "Oppretter en kontakt når en bruker klikker på \"Next\" på et hvilket som helst lysbilde – selv om de ikke fullfører spørreundersøkelsen.",
    "dragDrop": {
      "imageLabel": "Bilde {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Undersøkelse {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Personvernerklæring</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Vilkår for bruk</a></p>",
      "smsConsent": "Jeg samtykker til å motta SMS-varsler, alarmer og sporadisk markedsføringskommunikasjon fra bedriften. Meldingsfrekvensen varierer. Meldings- og dataavgifter kan påløpe. Send SMS med HELP til (XXX) XXX-XXXX for assistanse. Du kan når som helst svare STOP for å melde deg av."
    }
  },
  "form": {
    "typeOfBuilder": "Skjema",
    "formStyle": "Skjemastil",
    "formElement": "Skjemaelement",
    "addFormElement": "Legg til skjemaelement",
    "addConditionalLogic": "Legg til betinget logikk",
    "openConditionalLogic": "Åpne betinget logikk",
    "inlineForm": "Inline-skjema",
    "formName": "Skjemanavn",
    "fullScreenMode": "Fullskjermmodus",
    "fullScreenModetooltip": "Å slå den på vil føre til at skjemaet utvides over hele bredden på beholderen, og strekker seg til kanten av innebyggingsområdet mens det holder seg til skjemaets bredde.",
    "enableTimezoneForm": "Aktivering av dette alternativet vil fange opp tidssoneinformasjonen til personen som sender inn skjemaet",
    "formSettings": "Innstillinger for skjema",
    "scheduleVisibility": {
      "title": "Planlegg synligheten til {product}",
      "subtitle": "Angi når denne {product} skal begynne og slutte å motta svar. Utenfor dette perioden vil besøkende se meldingene du konfigurerer nedenfor.",
      "formOpens": "{Product} åpner",
      "formCloses": "{Product} lukkes",
      "rightAway": "Umiddelbart",
      "never": "Aldri",
      "pickADate": "Velg en dato",
      "opensPlaceholder": "Åpnes så snart du publiserer",
      "closesPlaceholder": "Forblir åpent til du lukker det",
      "date": "Dato",
      "time": "Tid",
      "timezone": "Tidssone",
      "timezoneHelp": "Gjelder for både åpnings- og lukketider.",
      "timezonePlaceholder": "Velg en tidssone",
      "timeline": {
        "notOpenYet": "Ikke åpent ennå",
        "acceptingResponses": "Godtar svar",
        "closed": "Lukket",
        "current": "Nåværende",
        "opens": "Åpnes",
        "closes": "Lukkes"
      },
      "whatVisitorsSee": "Hva besøkende ser",
      "whatVisitorsSeeHelp": "Disse sidene vises bare utenfor den åpne perioden. Velg en tilstand for å konfigurere den.",
      "states": {
        "beforeTitle": "Før {product} åpner",
        "afterTitle": "Etter at {product} lukkes",
        "showsPage": "Viser en egendefinert side",
        "redirectsTo": "Omdirigerer til {url}"
      },
      "showPage": "Vis en side",
      "showPageHelp": "Design hva besøkende ser.",
      "openLink": "Åpne en lenke",
      "openLinkHelp": "Send dem til en annen URL.",
      "redirectUrl": "Omdirigerings-URL",
      "redirectUrlPlaceholder": "https://example.com",
      "redirectUrlHelp": "Besøkende i denne tilstanden sendes hit i stedet for å se en side. Bruk en fullstendig URL, for eksempel https://example.com/path.",
      "redirectUrlInvalid": "Skriv inn en gyldig URL som starter med http:// eller https://, for eksempel https://eksempel.no/path.",
      "defaultBeforeMessage": "Denne {product} er ikke åpen ennå",
      "defaultAfterMessage": "Denne {product} er nå lukket",
      "defaultBeforeBody": "Dette {product} tar ikke imot svar ennå. Sjekk igjen når det åpner for å sende inn svaret ditt.",
      "defaultAfterBody": "Takk for interessen! Denne {product} har sluttet å godta svar. Ta kontakt med eieren av {product} hvis du fortsatt trenger å komme i kontakt.",
      "closeAfterOpenError": "Lukketid må være etter åpningstid.",
      "preview": {
        "label": "Forhåndsvisning",
        "labelHint": "– hvordan besøkende ser det",
        "redirectTo": "Du vil bli omdirigert til:",
        "poweredBy": "Drevet av byrået ditt"
      },
      "appearance": {
        "title": "Utseende",
        "cardBackground": "Kortbakgrunn",
        "pageBackground": "Sidebakgrunn",
        "cornerRadius": "Hjørneradius",
        "cardWidth": "Kortbredde",
        "cardHeight": "Korthøyde",
        "shadow": "Skygge",
        "autoPlaceholder": "Auto",
        "marginPadding": "Marg og utfylling",
        "auto": "auto",
        "miscellaneous": "Diverse",
        "agencyBranding": "Byråets merkevarebygging",
        "agencyBrandingHelp": "Vis byrålogoen og navnet til byrået ditt på sider i lukket tilstand.",
        "shadowOptions": {
          "none": "Ingen",
          "soft": "Myk",
          "elevated": "Hevet"
        },
        "colors": {
          "default": "Standard",
          "lightGray": "Lys grå",
          "brandTint": "Merkevaretone",
          "blush": "Blush",
          "dark": "Mørk",
          "white": "Hvit",
          "coolGray": "Kjølig grå"
        }
      }
    },
    "saveExitConfirmation": "Lagre fremdrift for skjemaer",
    "unsavedAlertMessage": "Skjemaet har ulagret arbeid. Er du sikker på at du vil forlate og forkaste alt arbeid som ikke er lagret?",
    "thirdPartyScriptAlertMessage": "Tredjepartsskript inne i HTML-blokken kan gi sterk funksjonalitet, men de medfører også risiko for personvern, sikkerhet, ytelse og sideoppførsel. Vi anbefaler derfor at du leser gjennom innholdet i dette skriptet før du lagrer det i skjemaet.",
    "onFormSubmission": "Ved innsending av skjema",
    "integrateForm": "Integrer skjema",
    "embedlayoutType": "Sett inn Type Oppsett",
    "embedlayoutTypeSubMessage": "Velg en layout som skal bygges inn i en trakt eller et eksternt nettsted",
    "triggerType": "Triggertype",
    "showOnScrolling": "Vis på scrolling",
    "showAfter": "Vis etter",
    "seconds": "sekunder",
    "alwaysShow": "Vis alltid",
    "activationOptions": "Aktiveringsalternativer",
    "activateOn": "Aktiver på",
    "visit": "besøk",
    "alwaysActivated": "Alltid aktivert",
    "deactivationOptions": "Alternativer for deaktivering",
    "deactivateAfterShowing": "Deaktiver etter visning",
    "times": "ganger",
    "deactiveOnceLeadCollected": "Deaktiveres når leaden er hentet inn",
    "neverDeactivate": "Aldri deaktivere",
    "copyEmbedCode": "Kopier innbyggingskode",
    "copyFormLink": "Kopier skjemalenke",
    "openFormLink": "Åpne skjemalenke",
    "inline": "Innebygd",
    "inlineDescription": "Et innebygd skjema vises sammen med innholdet på siden som et innebygd element. Det legges ikke over og kan ikke lukkes eller minimeres.",
    "inlineHoverDescription": "Et innebygd skjema vises sammen med innholdet på siden som et innebygd element. Det legges ikke over og kan ikke lukkes eller minimeres.",
    "popup": "Popup",
    "popupDescription": "En popup viser form som et overlegg inne i en lysboks. Den kan ikke minimeres, men lukkes.",
    "popupHoverDescription": "En popup viser form som et overlegg inne i en lysboks. Den kan ikke minimeres, men lukkes.",
    "politeSlideIn": "Høflig varsel",
    "politeSlideInDescription": "Et høflig varsel vises på bunnen av skjermen og forsvinner når den lukkes",
    "politeSlideInHoverDescription": "Vises nederst på skjermen og forsvinner når den lukkes",
    "stickySidebar": "Klistret sidefelt",
    "stickySidebarDescription": "Et klistret sidefelt vises på siden av skjermen og kan minimeres til en fane som fester seg til siden av vinduet",
    "stickySidebarHoverDescription": "Vises på siden av skjermen og kan minimeres til en fane som fester seg til siden av vinduet",
    "allowMinimize": "Tillat minimering",
    "checkForCookieConsent": "Respekter samtykke til informasjonskapsler fra vertsområdet",
    "checkForCookieConsentTooltip": "Pikselhendelser utløses bare etter at den besøkende godtar markedsføringscookies på nettstedet der dette skjemaet er innebygd. Automatisk oppdagelse ser etter GHL-CookieConsent, OneTrust, Cookiebot, Complianz, Usercentrics, TrustArc, Cookieyes, Iubenda, Termly, Osano, Didomi og IAB TCF.",
    "cookieConsentProvider": "Leverandør av samtykke til informasjonskapsler",
    "cookieConsentProviderPlaceholder": "Velg samtykkebanner for informasjonskapsler",
    "cookieConsentProviderAutoDetect": "Automatisk oppdagelse",
    "modalHeight": "Modalhøyde",
    "modalHeightPlaceholder": "Angi modalhøyde",
    "conditonalLogic": {
      "conditions": "Betingelser",
      "noExistingCondition": "Ingen eksisterende betingelser ennå",
      "freeRoamMessage": "Du kan bevege deg fritt uten regler – i hvert fall inntil videre",
      "addNewCondition": "Legg til ny betingelse",
      "redirectToUrl": "Omdiriger til URL",
      "displayCustomMessage": "Vis egendefinert melding",
      "disqualifyLead": "Diskvalifiser lead",
      "showHideFields": "Vis/skjul felt",
      "jumpTo": "Hopp til",
      "redirectToUrlSubText": "Omdiriger Bruker etter innsending",
      "displayCustomMessageSubText": "Vise-meldinger basert på På Bruker-innganger",
      "disqualifyLeadSubText": "Filtrere ut oppføringer under spesifikke betingelser",
      "showHideFieldsSubText": "Endre Følte Synlighet dynamisk",
      "openBelowUrl": "Åpne URL-en nedenfor",
      "showCustomMessage": "Vis egendefinert melding",
      "alertConditionDelete": "Er du sikker på at du vil slette denne betingelsen?",
      "deleteCondition": "Slett betingelse",
      "conditionExecutedMessage": "Betingelsene vil bli utført i rekkefølgen ovenfra og ned.",
      "anyVariant": "Enhver variant",
      "bumpSuffix": "Tilleggsbestilling",
      "untitledProduct": "Produkt uten tittel",
      "deletedProduct": "Slettet produkt",
      "deletedVariant": "Slettet variant",
      "allOperationOptions": {
        "isEqualTo": "Er lik",
        "isNotEqualTo": "Er ikke lik",
        "contains": "Inneholder",
        "doesNotContain": "Inneholder ikke",
        "startsWith": "Begynner med",
        "endsWith": "Slutter med",
        "isEmpty": "Er tom",
        "isFilled": "Er fylt",
        "before": "Før",
        "after": "Etter",
        "greaterThan": "Større enn",
        "lessThan": "Mindre enn",
        "between": "Mellom",
        "isChecked": "Er avkrysset",
        "isNotChecked": "Er ikke kontrollert",
        "isSelected": "Er valgt",
        "isNotSelected": "Er ikke valgt",
        "pricingOptionIs": "Prisalternativet er",
        "pricingOptionIsNot": "Prisalternativet er ikke"
      },
      "logic": {
        "if": "Hvis",
        "then": "Deretter",
        "and": "Og",
        "or": "Eller"
      },
      "phoneAlertMessage": "For å søke etter telefonnumre med landskode, må du inkludere «+»-symbolet i søket ditt.",
      "deleteAlertMessage": "Er du sikker på at du vil slette dette feltet? Betingelsen som er knyttet til dette feltet, vil også bli fjernet.",
      "deleteField": "Slett felt",
      "jumpToDescription": "Hopp til en bestemt lysbilde når betingelsene er oppfylt",
      "cycleError": "Kan ikke lagres. Gjentakende oppdaget mellom {a} og {b}",
      "jumpToSlide": "Gå til lysbilde",
      "submitSurvey": "Lagre spørreundersøkelse",
      "pageTitle": "P{index} – {title}",
      "selectSlideToJumpTo": "Velge Skyve å hoppe Fra",
      "selectedSlide": "Valgt lysbilde",
      "typeValueHere": "Vennligst Type en Verdi her",
      "field": "Felt",
      "slide": "Lysbilde",
      "selectFieldOrSlide": "Velg felt eller skyve",
      "selectFieldState": "Velg feltstatus",
      "selectField": "Velg felt",
      "quizFields": "Quizfelt",
      "standardFields": "Standardfelter",
      "highestScore": "Høyeste poengsum",
      "lowestScore": "Laveste poengsum",
      "overallScore": "Total poengsum",
      "categoryScore": "Kategoripoengsum",
      "selectCategory": "Velg kategori",
      "scoreFormat": "Poengsumformat",
      "percentage": "Prosentandel",
      "actualScore": "Faktisk poengsum",
      "outOf10": "Av 10",
      "selectOption": "Velg alternativ",
      "jumpToTarget": "Hopp til",
      "jumpToQuestion": "Gå til Spørsmål",
      "chooseQuestion": "Velg spørsmål",
      "includeStart": "Inkluder Start",
      "includeEnd": "Inkluder slutt",
      "includeValue": "Inkludere {value}",
      "hideField": "Skjul felt",
      "hideFields": "Skjul felter",
      "showField": "Vis felt",
      "showFields": "Vis felter",
      "additionalRulesPrefix": "… og",
      "additionalRulesSuffix": "andre {ifLabel} regler …",
      "shownTargetsWithMore": "{shown}, +{count} mer",
      "noConditionsAlt": "Ingen betingelser ennå",
      "outcomeLabels": {
        "show": "Vis",
        "jumpTo": "Hopp til"
      },
      "entireSection": "Hele seksjonen",
      "specificProducts": "Spesifikke produkter",
      "mainProduct": "Primærprodukt",
      "bumpProduct": "Fremhev produkt",
      "searchProductsOrVariants": "Søk i produkter eller varianter",
      "selectAll": "Velg alle",
      "clear": "Fjern",
      "variantsCount": "{count} varianter",
      "productsSelectedCount": "{selected} av {total} produkter",
      "selectAtLeastOneProduct": "Velg minst 1 produkt eller variant.",
      "productHint": {
        "entireHide": "Hele {section} -seksjonen er skjult når betingelsen er oppfylt.",
        "entireShow": "Hele {section} -seksjonen forblir skjult til betingelsen er oppfylt.",
        "specificHide": "De valgte elementene skjules når betingelsen er oppfylt.",
        "specificShow": "De valgte elementene forblir skjulte til betingelsen er oppfylt.",
        "allSelectedHide": "Alle produktene er valgt, så hele seksjonen vil bli skjult.",
        "allSelectedShow": "Alle produkter er valgt, så hele seksjonen forblir skjult til betingelsen er oppfylt."
      },
      "productsCountShort": "{count} produkter",
      "noProductsMatchSearch": "Ingen produkter samsvarer med dette søket.",
      "noProductsTitle": "Ingen produkter i dette feltet ennå",
      "noProductsBody": "Legg til produkter i {section} for å vise eller skjule dem ett og ett. Du kan fortsatt skjule hele delen.",
      "remove": "Fjern",
      "deletedProductTitleOne": "1 produkt finnes ikke lenger",
      "deletedProductTitleOther": "{count} produkter finnes ikke lenger",
      "deletedProductBodyOne": "Et valgt produkt ble fjernet fra {section}. Fjern det fra denne betingelsen for å lagre.",
      "deletedProductBodyOther": "De valgte produktene ble fjernet fra {section}. Fjern dem fra denne betingelsen for å lagre.",
      "selectPricingOption": "Velg prisalternativ",
      "selectProduct": "Velg produkt"
    },
    "minimizedTitlePlaceholder": "Minimert tittel",
    "dragYourElementFromLeft": "Dra elementene dine hit fra venstre",
    "formNotification": "Skjema for varsling",
    "sendSubmissionsAsPdf": "Send skjemainnsending som en PDF",
    "style": {
      "formPadding": "Skjema-padding"
    },
    "integratePopup": {
      "shareOrEmbed": "Bygg inn eller del skjema",
      "share": {
        "openFormLink": "Åpne Skjema Lenke"
      },
      "email": {
        "emailSubheader": "Skape en tom e-post og Sett inn din Skjema, Eller Velge a Mal og Sett inn it Umiddelbart."
      }
    },
    "choosePosition": "Velge Status",
    "testBuild": "Teststruktur"
  },
  "quiz": {
    "quizElement": "Quiz-element",
    "quizNotification": "Quiz-varsling",
    "viewAndCustomise": "Se og tilpass",
    "categoryAndScore": "Kategori og poengsum",
    "provideFeedback": "Gi tilbakemelding",
    "addQuizElement": "Legg til quiz-element",
    "typeOfBuilder": "Quiz",
    "addQuestions": "Legge til spørsmål",
    "dragAndDropQuestion": "Dra og slipp et Spørsmål her.",
    "addNewPage": "Legg til side",
    "editTemplate": "Redigere Mal",
    "editResultPage": "Rediger resultatside",
    "clonePage": "Klone side",
    "category": {
      "category": "Kategori",
      "useCategoryWhen": "Bruk Kategorier Når",
      "manageCategories": "Administrere Kategorier",
      "howItWorks2": "Hvordan fungerer dette",
      "addCategoryMessage": "Legge til en ny Kategori",
      "assignCategoryMessage": "Tilordne en Kategori til hvert eneste alternativ",
      "editResultsMessage": "Vise Kategori-score in Resultat Side",
      "toEvaluateTheResponder": "For å sammenligne responderen basert på flere faktorer",
      "showMultipleCategoryScore": "Vise flere Kategori-score in Resultat Side",
      "displayVaryingContent": "Visning varierende Innhold På resultatene Side avhengig På Kategori-poengsummen",
      "addManage": "Legge til / Administrere",
      "carouselAlt": "Forhåndsvisningslysbilde for kategori"
    },
    "quizSettings": "Quiz-innstillinger",
    "saveExitConfirmation": "Lagre fremdriften for quizer",
    "onQuizSubmission": "Ved innlevering av quiz",
    "settings": "Innstillinger",
    "deletePage": "Slett side",
    "quizResult": {
      "resultTemplate": "Resultatsidemal",
      "quizResultAlertMessage": "Den valgte resultatsiden vises når quizen er fullført",
      "overallScoreLabel": "Total poengsum",
      "resultTemplateAlt": "Forhåndsvisning av quizresultatmal"
    },
    "deleteSlideMessage": "Er du sikker på at du vil slette lysbildet?",
    "autoResponderSubheader": "Send en automatisk e-post til personen som sender inn quizen (e-posten inneholder en kopi av informasjonen de har lagt inn i quizen)",
    "sendSubmissionsAsPdf": "Send quizinnsending som en PDF",
    "sendQuizResultsAsPdf": "Send quizresultatet som en PDF",
    "integrateHeader": "Integrer quiz",
    "integrateSubHeader": "Bruk følgende alternativer for å integrere din egendefinerte quiz på nettstedet ditt",
    "integrateCopyLinkMessage": "Kopier lenken nedenfor og del den enkelt hvor du måtte ønske.",
    "pageLabel": "Side {n}",
    "pageName": "Sidenavn",
    "pagePosition": "Sideposisjon",
    "createContactOnPartialSubmissionSubText": "Oppretter en kontakt når en bruker klikker på \"Neste\" på et hvilket som helst lysbilde — selv om de ikke fullfører quizen.",
    "integratePopup": {
      "shareOrEmbed": "Bygg inn eller del quiz",
      "share": {
        "openFormLink": "Åpne quiz- Lenke"
      },
      "email": {
        "emailSubheader": "Skriv inn en tom e-post og sett inn quizen din, Eller Velge a Mal og Sett inn it Umiddelbart."
      }
    }
  },
  "integrate": {
    "embed": {
      "chooseType": "Velg type",
      "sidebar": "Sidefelt",
      "popover": "Popover",
      "popup": "Popup",
      "standard": "Standard",
      "formWidth": "Skjemabredde",
      "formHeight": "Skjemaets høyde",
      "showLauncher": "Vis {asset} -knappen",
      "showLauncherHelp": "Besøkende kan minimere og åpne {asset} igjen når som helst.",
      "position": "Velg posisjon",
      "left": "Venstre",
      "right": "Høyre",
      "buttonLabel": "Etikett for knapp",
      "buttonColor": "Farge på knapp",
      "buttonType": "Knappetype",
      "buttonSize": "Størrelse på knapp",
      "text": "Tekst",
      "iconAndText": "Ikon + tekst",
      "iconOnly": "Bare ikon",
      "small": "Lite",
      "medium": "Medium",
      "large": "Stort",
      "icon": "Ikon",
      "cornerRadius": "Hjørneradius",
      "linkCornerRadius": "Koble sammen verdiene for hjørneradius",
      "corner": {
        "tl": "Radius for øvre venstre hjørne",
        "tr": "Hjørneradius øverst til høyre",
        "bl": "Nedre venstre hjørneradius",
        "br": "Nedre høyre hjørneradius"
      },
      "fontSize": "Skriftstørrelse",
      "embedIn": "Sett inn i",
      "funnels": "Trakter",
      "websites": "Nettsteder",
      "settingsTitle": "Innstillinger for innbygging",
      "preview": "Forhåndsvisning",
      "previewHint": "Trykk på knappen for å se {type} i aksjon",
      "realPreviewTitle": "Forhåndsvisning av {asset}",
      "realPreviewUnavailable": "Forhåndsvisning i sanntid er ikke tilgjengelig. Viser et eksempel i stedet.",
      "ghostName": "Navn",
      "ghostNamePlaceholder": "Skriv inn navnet ditt",
      "ghostPhone": "Telefonnummer",
      "ghostPhonePlaceholder": "+1 (555) 123-4567",
      "ghostEmail": "E-postadresse",
      "ghostEmailPlaceholder": "eksempel{'@'}gmail.com",
      "ghostSubmit": "Send inn",
      "sidebarLower": "sidefelt",
      "popoverLower": "popover",
      "popupLower": "popup",
      "standardLower": "standardskjema",
      "general": "Generelt",
      "advanced": "Avansert",
      "embedCode": "Bygg inn kode",
      "triggerType": "Triggertype",
      "alwaysShow": "Vis alltid",
      "showAfter": "Vis etter",
      "showOnScrolling": "Vis på scrolling",
      "activation": "Aktiveringsalternativer",
      "alwaysActivated": "Alltid aktivert",
      "activateOnVisit": "Aktiver ved besøk",
      "deactivation": "Alternativer for deaktivering",
      "neverDeactivate": "Aldri deaktivere",
      "deactivateAfter": "Deaktiver etter visning",
      "leadCollected": "Når et kundeemne er hentet inn",
      "modalTitle": "Sett inn på nettside",
      "copyStep": "Kopier innebyggingskoden",
      "openWebpageStep": "Åpne nettsiden din",
      "openWebpageStepHelp": "Åpne sideeditoren og finn alternativet for å legge til HTML eller egendefinert kode.",
      "publishStep": "Lim inn koden og publiser",
      "publishStepHelp": "Lim inn innebyggingskoden i HTML-koden eller seksjonen for egendefinert kode, og lagre og publiser deretter siden.",
      "copyCode": "Kopier kode",
      "setupGuidePrompt": "Bruker du WordPress, Wix eller Webflow?",
      "viewSetupGuides": "Vis oppsettveiledninger"
    },
    "postSave": {
      "title": "Din {asset} er klar",
      "description": "Del det, bygg det inn eller koble til en arbeidsflyt når du er klar.",
      "embedForm": "Sett inn {asset}",
      "connect": "Koble til",
      "createWorkflow": "Opprett en arbeidsflyt",
      "workflowDescription": "Kjør en arbeidsflyt for hver innsending.",
      "dontShowAgain": "Ikke vis dette igjen"
    },
    "email": {
      "preview": "Forhåndsvisning",
      "shareViaEmail": "Del via e-post",
      "startFromScratch": "Start fra bunnen av",
      "emailMarketingTemplates": "E-postmarkedsføringsmaler",
      "templateImageAlt": "2000+ e-postmaler",
      "yourTemplates": "Dine maler",
      "selectTemplate": "Velg fra malene dine",
      "to": "Til:",
      "from": "Fra:",
      "inviteTitle": "Hei,",
      "inviteBody": "Jeg har invitert deg til å fylle ut et skjema:",
      "inviteAction": "Fyll ut skjemaet vårt"
    },
    "share": {
      "copyLink": "Del lenke",
      "copyLinkTitle": "Kopier lenken til {asset}",
      "copyLinkDescription": "Start med å samle inn innsendinger for {asset}. Enten du vil dele lenken eller bygge den inn et sted, har vi det du trenger.",
      "copyLinkButton": "Kopier lenke",
      "openLink": "Åpne lenken",
      "shareOnSocialMedia": "Del på sosiale medier",
      "socialDescription": "Del enkelt {asset} på foretrukne sosiale medieplattformer og begynn å samle inn innsendinger.",
      "qrCode": "QR-kode",
      "shareQr": "Del QR",
      "shareQrDescription": "Skann eller del denne QR-koden for å få umiddelbar tilgang til din {asset}.",
      "qrLoading": "Laster inn QR-kode ...",
      "qrLoadError": "QR-koden kunne ikke lastes inn. Prøv igjen.",
      "preview": "Forhåndsvisning",
      "social": {
        "facebook": "Del på Facebook",
        "whatsapp": "Del på WhatsApp",
        "linkedin": "Del på LinkedIn",
        "x": "Del på X"
      }
    }
  },
  "textEditor": {
    "textAlign": "Tekstjustering",
    "list": "Liste",
    "sourceCode": "Kildekode",
    "resetStyle": "Tilbakestill stil",
    "resetDocumentStyle": "Tilbakestill dokumentstil"
  },
  "builderValidation": {
    "ui": {
      "checking": "Brukskonto",
      "actionRequired": "Handling kreves",
      "errorSummary": "{n} feil må rettes før du kan lagre. Velg den for å gå til feilen.",
      "viewErrors": "Vis feil",
      "panelTitle": "Anbefalinger ({n})",
      "panelSubtitle": "Valgfrie tips for å forbedre {product}. Lagre når som helst.",
      "tabRecommendations": "Anbefalinger",
      "tabInsights": "Innsikt",
      "recommendationsPill": "Anbefalinger",
      "noRecommendationsTitle": "Ingenting å vurdere",
      "noRecommendationsBody": "Denne {product} har ingen anbefalinger. Du er klar til å lagre.",
      "settingTitle": "Vis {product} anbefalinger",
      "settingDescription": "Få smarte anbefalinger for å oppdage feil som har blitt oversett, forbedre {product} og få inn flere innsendinger",
      "dontShowAgain": "Ikke vis igjen",
      "allClearTitle": "Alt klart",
      "allClearBody": "Alt er løst. Du er klar til å lagre.",
      "openInsight": "Åpne {name} -innstillinger",
      "dontShowAgainHint": "Skjemaanbefalinger blir slått av, men du kan aktivere dem når som helst fra fanen Innstillinger.",
      "panelLabel": "Anbefalinger"
    },
    "errors": {
      "urlFieldDomainsMissing": "Et URL-felt begrenser domener, men ingen er oppført.",
      "pictureChoiceImageMissing": "Et bildevalgsalternativ har ikke noe bilde.",
      "pictureChoiceLabelMissing": "Et bildevalgsalternativ mangler etikett.",
      "pictureChoiceDuplicateLabels": "To bildevalgsalternativer har samme etikett.",
      "pictureChoiceSelectionLimitInvalid": "Grensen for antall bildevalg er høyere enn antallet alternativer.",
      "datetimeLabelEmpty": "Et dato- og tidsfelt har ingen etikett.",
      "datetimeTimeFormatInvalid": "Et dato- og tidsfelt har et ugyldig standardklokkeslett.",
      "datetimeNoAvailableDays": "Et dato- og tidsfelt har ingen tilgjengelige dager å velge.",
      "datetimeDateRangeInvalid": "Et felt for dato og klokkeslett har et ufullstendig eller omvendt datointervall.",
      "datetimeTimeRangeInvalid": "Et dato- og tidsfelt har et ufullstendig eller omvendt tidsintervall.",
      "opportunitySettingsIncomplete": "Dette skjemaet samler inn mulighetsfelter, men ingen prosessfase er angitt.",
      "footerStylesInvalid": "Innstillingene for bunnteksten er ufullstendige.",
      "emptyCustomFieldLabel": "Et egendefinert felt har ingen etikett.",
      "duplicateCustomFieldName": "To felt har samme etikett \"{name}.\"",
      "sellProductsNoProduct": "Et produktelement har ingen produkter eller fremhevede produkter.",
      "imageMissing": "Et bildeelement har ikke noe bilde.",
      "scoreCalculationEmpty": "Et poengelement har ingen felt i beregningen."
    },
    "errorsInline": {
      "urlFieldDomainsMissing": "Ingen domener lagt til",
      "pictureChoiceImageMissing": "Ingen bilder lagt til",
      "pictureChoiceLabelMissing": "Manglende etikett",
      "pictureChoiceDuplicateLabels": "Dupliser etikett",
      "pictureChoiceSelectionLimitInvalid": "Ugyldig valgbegrensning",
      "datetimeLabelEmpty": "Manglende etikett",
      "datetimeTimeFormatInvalid": "Ugyldig tid",
      "datetimeNoAvailableDays": "Ingen dager valgt",
      "datetimeDateRangeInvalid": "Ugyldig datoperiode",
      "datetimeTimeRangeInvalid": "Ugyldig tidsperiode",
      "opportunitySettingsIncomplete": "Prosessfase mangler",
      "footerStylesInvalid": "Bunntekstinnstillinger ufullstendige",
      "emptyCustomFieldLabel": "Manglende etikett",
      "duplicateCustomFieldName": "Dupliser etikett",
      "sellProductsNoProduct": "Ingen produkter er lagt til",
      "imageMissing": "Ingen bilder lagt til",
      "scoreCalculationEmpty": "Ingen felt lagt til"
    },
    "errorsAction": {
      "urlFieldDomainsMissing": "Legg til domene",
      "pictureChoiceImageMissing": "Legg til bilde",
      "pictureChoiceLabelMissing": "Legg til en etikett",
      "pictureChoiceDuplicateLabels": "Gi nytt navn til duplisert etikett",
      "pictureChoiceSelectionLimitInvalid": "Korriger grensen for valg",
      "datetimeLabelEmpty": "Legg til en etikett",
      "datetimeTimeFormatInvalid": "Fiks standardtid",
      "datetimeNoAvailableDays": "Velg ledige dager",
      "datetimeDateRangeInvalid": "Korriger datoperiode",
      "datetimeTimeRangeInvalid": "Korriger tidsintervallet",
      "opportunitySettingsIncomplete": "Åpne innstillinger for muligheter",
      "footerStylesInvalid": "Åpne innstillinger for bunntekst",
      "emptyCustomFieldLabel": "Legg til en etikett",
      "duplicateCustomFieldName": "Gi nytt navn til duplisert etikett",
      "sellProductsNoProduct": "Legg til produkter",
      "imageMissing": "Legg til bilde",
      "scoreCalculationEmpty": "Legg til felt"
    },
    "recommendations": {
      "termsConditionsMissing": "Innhent samtykke før du lagrer besøksdata.",
      "captchaMissing": "Beskytt dette skjemaet mot innsending av søppelpost.",
      "privacyPolicyUrlMissing": "Samtykketeksten lenker fortsatt til example.com.",
      "sellProductsNotLive": "Betalingen er i testmodus, så ingen penger vil bli trukket.",
      "defaultCustomFieldName": "Standardetiketter gjør innsendinger vanskelige å lese.",
      "emptyCustomFieldLabelExisting": "Et felt har ingen etikett, så besøkende vil ikke vite hva de skal skrive inn.",
      "quizOptionPlaceholder": "Svarene i \"{label}\" bruker fortsatt standardnavnene på alternativene.",
      "quizScoreBlank": "Et svar har ingen poengsum og vil derfor ikke telle med i et resultat.",
      "quizCtaUrlMissing": "Knappen på resultatsiden har ingen destinasjon.",
      "quizCtaUrlPlaceholder": "Knappen på resultatsiden lenker fortsatt til example.com.",
      "headerTextEmpty": "Et tekstelement er tomt.",
      "htmlElementEmpty": "Et HTML-element har ikke noe innhold.",
      "buttonTextEmpty": "Send inn-knappen har ingen tekst.",
      "sourceFieldValueEmpty": "Et skjult kildefelt har ingen verdi, så ingenting spores.",
      "optionLabelEmpty": "Et svaralternativ mangler etikett.",
      "fileUploadMaxSizeInvalid": "Grensen for filopplasting er ikke et gyldig tall.",
      "submitRedirectUrlMissing": "Innsendinger omdirigeres et sted, men ingen adresse er angitt.",
      "submitRedirectUrlInvalid": "Omdirigeringsadressen etter innsending er ikke en gyldig URL.",
      "disqualifyUrlMissing": "Diskvalifiserte besøkende blir omdirigert, men ingen adresse er angitt.",
      "disqualifyMessageEmpty": "Diskvalifiserte besøkende får se en tom melding.",
      "scheduleRedirectUrlInvalid": "En adresse for en planlagt omdirigering er ikke en gyldig URL.",
      "scheduleNoClosedStateContent": "En planlagt tilstand viser ingenting til besøkende.",
      "notificationRecipientMissing": "E-postvarsler er aktivert, men det er ingen mottakere.",
      "notificationEmailInvalid": "En varslingsmottaker er ikke en gyldig e-postadresse.",
      "logicOrphanFieldReference": "En logikkregel viser til et felt som ikke lenger finnes, og blir derfor aldri kjørt.",
      "logicOrphanOptionReference": "En logikkregel peker på et svaralternativ som ikke lenger finnes.",
      "logicOrphanTarget": "En logikkregel hopper til en side som ikke lenger finnes.",
      "scoreCalculationInvalidReference": "En poengberegning bruker et felt som ikke lenger finnes.",
      "assetHasNoElements": "Ingen spørsmål er lagt til ennå, så det er ingenting å samle inn."
    },
    "recommendationsAction": {
      "termsConditionsMissing": "Legg til felt for vilkår og betingelser",
      "captchaMissing": "Legg til botbeskyttelse",
      "privacyPolicyUrlMissing": "Oppdater lenkene",
      "sellProductsNotLive": "Slå på livemodus",
      "defaultCustomFieldName": "Gi nytt navn til \"{label}\"",
      "emptyCustomFieldLabelExisting": "Legg til en etikett",
      "quizOptionPlaceholder": "Gi alternativene nytt navn",
      "quizScoreBlank": "Legg til en poengsum",
      "quizCtaUrlMissing": "Legg til en lenke",
      "quizCtaUrlPlaceholder": "Oppdater lenken",
      "headerTextEmpty": "Legg til tekst",
      "htmlElementEmpty": "Legg til innhold",
      "buttonTextEmpty": "Legg til knappetekst",
      "sourceFieldValueEmpty": "Legg til en verdi",
      "optionLabelEmpty": "Legg til en etikett",
      "fileUploadMaxSizeInvalid": "Angi en grense",
      "submitRedirectUrlMissing": "Legg til en omdirigerings-URL",
      "submitRedirectUrlInvalid": "Rett omdirigerings-URL-en",
      "disqualifyUrlMissing": "Legg til en omdirigerings-URL",
      "disqualifyMessageEmpty": "Legg til en melding",
      "scheduleRedirectUrlInvalid": "Rett omdirigerings-URL-en",
      "scheduleNoClosedStateContent": "Legg til innhold",
      "notificationRecipientMissing": "Legg til en mottaker",
      "notificationEmailInvalid": "Korriger adressen",
      "logicOrphanFieldReference": "Gjennomgangslogikk",
      "logicOrphanOptionReference": "Gjennomgangslogikk",
      "logicOrphanTarget": "Gjennomgangslogikk",
      "scoreCalculationInvalidReference": "Korriger beregningen",
      "assetHasNoElements": "Legg til ditt første spørsmål"
    },
    "insights": {
      "heading": "En oversikt over skjemaoppsettet ditt.",
      "conditionalLogic": "Betinget logikk",
      "submitDestination": "Handling ved innsending",
      "customFields": "Egendefinerte felt",
      "paymentMode": "Betalingsmodus",
      "emailNotification": "E-postvarsel",
      "autoResponder": "Automatisk svar",
      "quizCategories": "Quizkategorier",
      "ruleCount": "{n} regler",
      "on": "På",
      "off": "Av",
      "live": "Direkte",
      "test": "Test",
      "destinationUrl": "Omdirigerings-URL",
      "destinationMessage": "Melding",
      "destinationOrder": "Ordrebekreftelse",
      "destinationQuizResult": "Quizresultat"
    },
    "groups": {
      "fields": "Felter",
      "questions": "Spørsmål",
      "questionsPage": "Spørsmålsside",
      "resultsPage": "Resultatside",
      "payments": "Betalinger",
      "settings": "Innstillinger"
    }
  }
}
